<template>
  <div class="home">
                <section>
                    <div class="py-8 px-8">
                    <div class="d-flex flex-wrap align-items-center justify-content-between">
                        <div class="col-12 col-lg-auto mb-4 mb-lg-0">
                        <div class="d-flex align-items-center">
                            <h4 class="mb-0 me-2">{{$t('settings')}}</h4>
                        </div>
                        </div>
                    </div>
                    </div>
                </section>
            
            <section class="px-8 mb-6">
                <div class="py-sm-2 px-sm-2" style="padding-bottom:6rem !important">
                        <div v-if="loading" class="d-flex flex-column align-items-center justify-content-center" style="min-height: 400px;">
                            <div class="premium-spinner"></div>
                            <h6 class="mt-4 text-muted fw-medium">{{$t('loading')}}...</h6>
                        </div>
                        <div v-else>
                            <ul class="nav nav-tabs">
                                
                                <li class="nav-item">
                                    <button style="padding:0.5rem!important" class="flex-sm-fill text-sm-center nav-link p-2" @click="handleTabChange('business')" :class="step == 'business' ? 'active' : ''" >{{$t('general')}}</button>
                                </li>
                                
                                <!-- <li class="nav-item">
                                    <button style="padding:0.5rem!important" class="flex-sm-fill text-sm-center nav-link" @click="step = 'reference_builder' " :class="step == 'reference_builder' ? 'active' : ''" >References</button>
                                </li> -->
                                
                                <li class="nav-item d-none d-md-block" v-if="false">
                                    <button style="padding:0.5rem!important" class="flex-sm-fill text-sm-center nav-link" @click="handleTabChange('templates')" :class="step == 'templates' ? 'active' : ''" >{{ $t('templates') }}</button>
                                </li>


                                <li class="nav-item" v-if="!business.affiliate_id">
                                    <button style="padding:0.5rem!important" class="flex-sm-fill text-sm-center nav-link" @click="handleTabChange('modules')" :class="step == 'modules' ? 'active' : ''" >{{ $t('modules') }}</button>
                                </li>

                                <li class="nav-item" v-if="!business.affiliate_id">
                                    <button style="padding:0.5rem!important" class="flex-sm-fill text-sm-center nav-link" @click="handleTabChange('integrations')" :class="step == 'integrations' ? 'active' : ''" >{{$t('integrations')}}</button>
                                </li>

                                <li class="nav-item" v-if="!business.affiliate_id">
                                    <button style="padding:0.5rem!important" class="flex-sm-fill text-sm-center nav-link" @click="handleTabChange('billing')" :class="step == 'billing' ? 'active' : ''" >{{$t('billing')}}</button>
                                </li>

                                <li class="nav-item" v-if="false">
                                    <button style="padding:0.5rem!important" class="flex-sm-fill text-sm-center nav-link" @click="handleTabChange('advanced')" :class="step == 'advanced' ? 'active' : ''" >{{ $t('advanced') }}</button>
                                </li>

                                <li class="nav-item">
                                    <button style="padding:0.5rem!important" class="flex-sm-fill text-sm-center nav-link" @click="handleTabChange('security')" :class="step == 'security' ? 'active' : ''" >{{ $t('security') }}</button>
                                </li>

                                </ul>

                            <nav class="nav nav-pills flex-column flex-sm-row mb-6">
                            </nav>

                            <div class="card py-8 px-8 row mb-4">
                                <div class="col-12">
                                    <div class="tab-content settings-container" id="nav-tabContent">

                                        <!-- business -->
                                        <div v-if="step == 'business'" class="container-fluid show fade" id="list-home" role="tabpanel" aria-labelledby="list-home-list">
                                            
                                            <!-- Simplified Container (No border/shadow) -->
                                            <div class="invoice-simulator-card rounded-4 p-3 p-md-4 bg-white mt-3 mb-4 overflow-hidden position-relative">
                                                
                                                <!-- Actions Top Right -->
                                                <div class="position-absolute top-0 end-0 p-2  z-index-10">
                                                    <div class="dropdown">
                                                        <button class="btn btn-light btn-sm px-3 py-2 rounded-pill shadow-sm dropdown-toggle border mb-3" type="button" data-bs-toggle="dropdown" aria-expanded="false" style="font-size: 13px; font-weight: 600;">
                                                            <AppIcon name="bi-three-dots-vertical" class="bi bi-three-dots-vertical me-1" />{{$t('actions')}}
                                                        </button>
                                                        <ul class="dropdown-menu dropdown-menu-end shadow border-0 mt-2">
                                                            <li>
                                                                <a class="dropdown-item py-2" href="#" @click.prevent="openPaymentMethodsModal">
                                                                    <AppIcon name="bi-credit-card" class="bi bi-credit-card me-2 opacity-75" />{{$t('manage_payment_methods')}}
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a class="dropdown-item py-2" href="#" @click.prevent="showAdvanced">
                                                                    <AppIcon name="bi-gear-wide-connected" class="bi bi-gear-wide-connected me-2 opacity-75" />{{$t('custom_fields')}}
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <!-- Integrated Business Identity Layout -->
                                                <div class="row g-4">
                                                    <!-- Left Column: Logo & Business Identity -->
                                                    <div class="col-md-6 border-md-end border-light pe-md-4">
                                                        <!-- Logo Section -->
                                                        <div class="mb-4 pb-2">
                                                            <label class="form-label text-dark fw-bold text-uppercase ls-1 mb-3" style="font-size: 12px;">{{$t('logo')}}</label>
                                                            <div class="logo-upload-wrapper position-relative" style="width: 120px; height: 120px;">
                                                                <input type="file" style="display:none" ref="input1" @change="previewImage" accept="image/*" >
                                                                <div class="logo-preview-box border rounded-4 d-flex align-items-center justify-content-center h-100 overflow-hidden position-relative cursor-pointer" 
                                                                     @mouseenter="hoverLogo = true" @mouseleave="hoverLogo = false"
                                                                     @click="$refs.input1.click()"
                                                                     style="border: 2px dashed #e2e8f0; background: #fafafa; transition: all 0.2s ease;">
                                                                    
                                                                    <button v-show="hoverLogo && !loadingImage && business.logo" @click.stop.prevent="deleteLogo" 
                                                                            class="btn btn-danger btn-sm position-absolute shadow-sm" 
                                                                            style="top: 10px; right: 10px; z-index: 10; border-radius: 50%; width:28px; height:28px; padding:0;">
                                                                        <AppIcon name="bi-x" class="bi bi-x fs-5" />
                                                                    </button>

                                                                    <img v-if="!loadingImage && business.logo" :src="business.logo" class="img-fluid" style="max-height: 100%; object-fit: contain; mix-blend-mode: multiply;">
                                                                    <div v-if="!loadingImage && !business.logo" class="text-center">
                                                                        <AppIcon name="bi-image" class="bi bi-image fs-1 text-secondary opacity-25" />
                                                                         <p class="mb-0 mt-2 fw-medium" style="font-size: 11px; color: #000;">{{$t('upload')}}</p>
                                                                    </div>
                                                                    <div v-if="loadingImage" class="spinner-border text-primary" role="status"></div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <!-- Identity Fields -->
                                                        <div class="d-flex flex-column gap-3">
                                                            <div class="mb-1">
                                                                 <label class="form-label text-dark fw-bold text-uppercase ls-1 mb-2" style="font-size: 12px;">{{$t('name')}}</label>
                                                                <input type="text" v-model="business.name" 
                                                                       class="form-control border bg-transparent py-2 px-3 rounded-4 shadow-none invoice-title-input" 
                                                                       :placeholder="$t('name')" 
                                                                        style="font-size: 0.9rem; color: #000; border-color: #e2e8f0 !important;">
                                                            </div>

                                                            <div>
                                                                 <label class="form-label text-dark fw-bold text-uppercase ls-1 mb-2" style="font-size: 12px;">{{$t('address')}}</label>
                                                                 <textarea v-model="business.address" @input="isDirty = true" class="form-control border bg-transparent py-2 px-3 rounded-4 shadow-none" rows="3" :placeholder="$t('address')" style="font-size: 0.9rem; color: #000; border-color: #e2e8f0 !important;"></textarea>
                                                            </div>

                                                            <div class="row g-3">
                                                                <div class="col-sm-6">
                                                                     <label class="form-label text-dark fw-bold text-uppercase ls-1 mb-2" style="font-size: 12px;">{{$t('phone')}}</label>
                                                                    <div class="input-group border rounded-4 overflow-hidden" style="border-color: #e2e8f0 !important;">
                                                                        <span class="input-group-text bg-transparent border-0 pe-1 opacity-50"><AppIcon name="bi-telephone" class="bi bi-telephone" /></span>
                                                                         <input type="text" v-model="business.phone" @input="isDirty = true" class="form-control border-0 bg-transparent py-2 shadow-none" :placeholder="$t('phone')" style="font-size: 0.9rem; color: #000;">
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-6">
                                                                     <label class="form-label text-dark fw-bold text-uppercase ls-1 mb-2" style="font-size: 12px;">{{$t('email')}}</label>
                                                                    <div class="input-group border rounded-4 overflow-hidden" style="border-color: #e2e8f0 !important;">
                                                                        <span class="input-group-text bg-transparent border-0 pe-1 opacity-50"><AppIcon name="bi-envelope" class="bi bi-envelope" /></span>
                                                                         <input type="text" v-model="business.email" @input="isDirty = true" class="form-control border-0 bg-transparent py-2 shadow-none" :placeholder="$t('email')" style="font-size: 0.9rem; color: #000;">
                                                                    </div>
                                                                </div>
                                                                <div class="col-12 mt-3">
                                                                     <label class="form-label text-dark fw-bold text-uppercase ls-1 mb-2" style="font-size: 12px;">{{$t('website')}}</label>
                                                                    <div class="input-group border rounded-4 overflow-hidden" style="border-color: #e2e8f0 !important;">
                                                                        <span class="input-group-text bg-transparent border-0 pe-1 opacity-50"><AppIcon name="bi-link-45deg" class="bi bi-link-45deg" /></span>
                                                                         <input type="text" v-model="business.website" @input="isDirty = true" class="form-control border-0 bg-transparent py-2 shadow-none" :placeholder="$t('website')" style="font-size: 0.9rem; color: #000;">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Right Column: General Config & Billing -->
                                                    <div class="col-md-6 ps-md-4 pt-md-3">
                                                         <h6 class="text-uppercase text-dark fw-bold ls-1 mb-3 pb-2 border-bottom border-light" style="font-size: 13px;">{{$t('general_info')}}</h6>
                                                        
                                                        <div class="mb-4">
                                                            <div class="mb-3 row align-items-center g-3">
                                                                 <label class="col-sm-5 text-dark fw-bold" style="font-size: 12px; color: #000 !important;">{{$t('vat')}} (%)</label>
                                                                <div class="col-sm-7">
                                                                    <div class="input-group input-group-sm rounded-3 overflow-hidden border bg-white shadow-none">
                                                                         <input type="number" v-model="business.vat" @input="isDirty = true" class="form-control border-0 ps-3" placeholder="0" style="font-size: 0.9rem; color: #000;">
                                                                         <span class="input-group-text border-0 bg-white pe-3 opacity-50 fw-bold" style="color: #000;">%</span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="mb-3 row align-items-center g-3">
                                                                 <label class="col-sm-5 text-dark fw-bold" style="font-size: 12px; color: #000 !important;">{{$t('currency')}}</label>
                                                                <div class="col-sm-7">
                                                                     <select v-model="business.currency" @change="isDirty = true" class="form-select form-select-sm border border-secondary border-opacity-10 rounded-3 ps-3 shadow-none" style="font-size: 0.9rem; color: #000;">
                                                                        <option value="dh">DH (Moroccan Dirham)</option>
                                                                        <option value="DZD">DZD (Algerian Dinar)</option>
                                                                        <option value="EGP">E£ (Egyptian Pound)</option>
                                                                        <option value="DT">DT (Tunisian Dinar)</option>
                                                                        <option value="$">$ (US Dollar)</option>
                                                                        <option value="€">€ (Euro)</option>
                                                                        <option value="£">£ (British Pound)</option>
                                                                        <option value="¥">¥ (Japanese Yen)</option>
                                                                        <option value="₹">₹ (Indian Rupee)</option>
                                                                        <option value="₩">₩ (South Korean Won)</option>
                                                                        <option value="₽">₽ (Russian Ruble)</option>
                                                                        <option value="₴">₴ (Ukrainian Hryvnia)</option>
                                                                        <option value="₺">₺ (Turkish Lira)</option>
                                                                        <option value="A$">A$ (Australian Dollar)</option>
                                                                        <option value="C$">C$ (Canadian Dollar)</option>
                                                                        <option value="R$">R$ (Brazilian Real)</option>
                                                                        <option value="NZ$">NZ$ (New Zealand Dollar)</option>
                                                                        <option value="HK$">HK$ (Hong Kong Dollar)</option>
                                                                        <option value="SG$">SG$ (Singapore Dollar)</option>
                                                                        <option value="R">R (South African Rand)</option>
                                                                        <option value="AOA">AOA (Angolan Kwanza)</option>
                                                                        <option value="XOF">XOF (West African CFA Franc)</option>
                                                                        <option value="BWP">BWP (Botswana Pula)</option>
                                                                        <option value="CDF">CDF (Congolese Franc)</option>
                                                                        <option value="XAF">XAF (Central African CFA Franc)</option>
                                                                        <option value="DJF">DJF (Djiboutian Franc)</option>
                                                                        <option value="ERN">ERN (Eritrean Nakfa)</option>
                                                                        <option value="ETB">ETB (Ethiopian Birr)</option>
                                                                        <option value="GHS">GHS (Ghanaian Cedi)</option>
                                                                        <option value="GMD">GMD (Gambian Dalasi)</option>
                                                                        <option value="GNF">GNF (Guinean Franc)</option>
                                                                        <option value="KES">KES (Kenyan Shilling)</option>
                                                                        <option value="KMF">KMF (Comorian Franc)</option>
                                                                        <option value="LRD">LRD (Liberian Dollar)</option>
                                                                        <option value="LSL">LSL (Lesotho Loti)</option>
                                                                        <option value="LYD">LYD (Libyan Dinar)</option>
                                                                        <option value="MGA">MGA (Malagasy Ariary)</option>
                                                                        <option value="MWK">MWK (Malawian Kwacha)</option>
                                                                        <option value="MRU">MRU (Mauritanian Ouguiya)</option>
                                                                        <option value="MUR">MUR (Mauritian Rupee)</option>
                                                                        <option value="MZN">MZN (Mozambican Metical)</option>
                                                                        <option value="NAD">NAD (Namibian Dollar)</option>
                                                                        <option value="NGN">₦ (Nigerian Naira)</option>
                                                                        <option value="RWF">RWF (Rwandan Franc)</option>
                                                                        <option value="SCR">SCR (Seychellois Rupee)</option>
                                                                        <option value="SDG">SDG (Sudanese Pound)</option>
                                                                        <option value="SHP">SHP (Saint Helena Pound)</option>
                                                                        <option value="SLL">SLL (Sierra Leonean Leone)</option>
                                                                        <option value="SOS">SOS (Somali Shilling)</option>
                                                                        <option value="SSP">SSP (South Sudanese Pound)</option>
                                                                        <option value="STN">STN (São Tomé and Príncipe Dobra)</option>
                                                                        <option value="SZL">SZL (Swazi Lilangeni)</option>
                                                                        <option value="TZS">TZS (Tanzanian Shilling)</option>
                                                                        <option value="UGX">UGX (Ugandan Shilling)</option>
                                                                        <option value="ZMW">ZMW (Zambian Kwacha)</option>
                                                                        <option value="ZWL">ZWL (Zimbabwean Dollar)</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            <div class="mb-0 row align-items-center g-3">
                                                                 <label class="col-sm-5 text-dark fw-bold" style="font-size: 12px; color: #000 !important;">{{$t('language')}}</label>
                                                                <div class="col-sm-7">
                                                                    <select v-model="business.language" @change="isDirty = true" class="form-select form-select-sm border border-secondary border-opacity-10 rounded-3 ps-3 shadow-none" style="font-size: 0.9rem; color: #000;">
                                                                        <option value="en">🇺🇸 English</option>
                                                                        <option value="fr">🇫🇷 French</option>
                                                                        <option value="ar">🇲🇦 Arabic (beta)</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="mb-4">
                                                            <h6 class="text-uppercase text-dark fw-bold ls-1 mb-3" style="font-size: 13px;"><AppIcon name="bi-bank" class="bi bi-bank me-2" />{{$t('billing_info')}}</h6>
                                                            <textarea v-model="business.billing_info" @input="isDirty = true" class="form-control border bg-transparent p-3 rounded-4 shadow-none" rows="3" placeholder="RIB, Swift, Bank details..." style="font-size: 0.9rem; color: #000; border-color: #e2e8f0 !important;"></textarea>
                                                        </div>

                                                        <div class="mb-0">
                                                            <h6 class="text-uppercase text-dark fw-bold ls-1 mb-3" style="font-size: 13px;"><AppIcon name="bi-clock-history" class="bi bi-clock-history me-2" />{{$t('payment_term')}}</h6>
                                                            <textarea class="form-control border bg-transparent p-3 rounded-4 shadow-none" v-model="business.payment_term" @input="isDirty = true" rows="2" style="font-size: 0.9rem; color: #000; border-color: #e2e8f0 !important;"></textarea>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Footer Section: Stamp & Extra -->
                                                <div class="mt-4 pt-4 border-top border-light">
                                                    <div class="row g-4 align-items-end">
                                                        <!-- Electronic Stamp / Signature -->
                                                        <div class="col-sm-5 col-md-4">
                                                            <label class="text-uppercase text-dark fw-bold ls-1 mb-3 d-block text-center" style="font-size: 12px;">{{$t('electronic_stamp')}}</label>
                                                            <div class="stamp-box p-4 border rounded-4 text-center bg-white position-relative overflow-hidden shadow-sm d-flex align-items-center justify-content-center" style="min-height: 180px; border: 2px dashed #e2e8f0 !important;">
                                                                <input type="file" style="display:none" ref="inputStamp" @change="previewStamp" accept="image/*" >
                                                                
                                                                <button v-show="hoverStamp && !loadingStamp && business.electronic_stamp" @click.stop.prevent="deleteStamp" 
                                                                        class="btn btn-danger btn-sm position-absolute shadow-sm" 
                                                                        @mouseenter="hoverStamp = true"
                                                                        style="top: 10px; right: 10px; z-index: 10; border-radius: 50%; width:28px; height:28px; padding:0;">
                                                                    <AppIcon name="bi-x" class="bi bi-x fs-5" />
                                                                </button>

                                                                <div @mouseenter="hoverStamp = true" @mouseleave="hoverStamp = false" @click="$refs.inputStamp.click()" class="w-100 h-100 cursor-pointer d-flex align-items-center justify-content-center px-3">
                                                                    <img v-if="!loadingStamp && business.electronic_stamp" :src="business.electronic_stamp" class="img-fluid" style="max-height: 130px; filter: contrast(1.1) grayscale(1); mix-blend-mode: multiply;">
                                                                    <div v-else-if="!loadingStamp" class="text-center opacity-25">
                                                                        <AppIcon name="bi-pencil-square" class="bi bi-pencil-square fs-1" />
                                                                         <p class="mb-0 fw-bold mt-2 text-uppercase ls-1" style="font-size: 11px; color: #000;">{{$t('upload')}}</p>
                                                                    </div>
                                                                    <div v-if="loadingStamp" class="spinner-border text-primary"></div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <!-- Extra Notes Section (Extra Fields) -->
                                                        <div class="col-sm-7 col-md-8">
                                                            <div class="row g-4" v-if="business.extra_fields && business.extra_fields.length > 0">
                                                                <div class="col-sm-6" v-for="(field, index) in business.extra_fields" :key="index">
                                                                    <label class="form-label text-dark fw-bold text-uppercase ls-1 mb-2" style="font-size: 12px;">{{$t(field.field_name)}}</label>
                                                                    <textarea v-model="field.field_value" @input="isDirty = true" class="form-control border bg-transparent p-3 rounded-4 shadow-none" rows="2" style="font-size: 0.85rem; color: #000; border-color: #e2e8f0 !important;"></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            <!-- Main Action Button -->
                                            <div class="row mt-4 mb-5">
                                                <div class="col-12 px-2">
                                                    <button class="btn btn-success btn-lg w-100 shadow rounded-pill py-3 fw-bold ripple mb-5" :disabled="loading" @click="save">
                                                        <AppIcon name="bi-check2-circle" class="bi bi-check2-circle me-2 fs-5" />{{$t('save')}}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    
                                        <!-- refrence builder -->
                                        <!-- <div v-if="step == 'reference_builder'" class="show fade" id="list-profile" role="tabpanel" aria-labelledby="list-profile-list">
                                            <div class="row">
                                                <div class="col-sm-12 col-md-12 col-lg-4">
                                                    <div class="mb-3">
                                                        <label for="exampleFormControlInput1"  class="form-label">{{$t('quote_reference_template')}}</label>
                                                        <input v-model="business.metadata.references.quote" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Reference" max="50">
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-12 col-lg-4">
                                                    <div class="mb-3">
                                                        <label for="exampleFormControlInput1"  class="form-label">{{$t('delivery_reference_template')}}</label>
                                                        <input v-model="business.metadata.references.delivery" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Reference" max="50">
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-12 col-lg-4">
                                                    <div class="mb-3">
                                                        <label for="exampleFormControlInput1"  class="form-label">{{$t('invoice_reference_template')}}</label>
                                                        <input v-model="business.metadata.references.invoice" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Reference" max="50">
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-12 col-lg-4">
                                                    <div class="mb-3">
                                                        <label for="exampleFormControlInput1"  class="form-label">{{$t('return_reference_template')}}</label>
                                                        <input v-model="business.metadata.references.return" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Reference" max="50">
                                                    </div>
                                                </div>
                                                
                                                <div class="col-sm-12 col-md-12 col-lg-4">
                                                    <div class="mb-3">
                                                        <label for="exampleFormControlInput1"  class="form-label">{{$t('order_reference_template')}}</label>
                                                        <input v-model="business.metadata.references.order" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Reference" max="50">
                                                    </div>
                                                </div>
                                                <hr class="m-4">
                                                <div class="col-sm-12 col-md-12 col-lg-4">
                                                    <div class="mb-3">
                                                        <label for="exampleFormControlInput1"  class="form-label">{{$t('purchase_reference_template')}}</label>
                                                        <input v-model="business.metadata.references.purchase" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Reference" max="50">
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-12 col-lg-4">
                                                    <div class="mb-3">
                                                        <label for="exampleFormControlInput1"  class="form-label">{{$t('reception_reference_template')}}</label>
                                                        <input v-model="business.metadata.references.reception" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Reference" max="50">
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-12 col-lg-4">
                                                    <div class="mb-3">
                                                        <label for="exampleFormControlInput1"  class="form-label">{{$t('return_reference_template')}}</label>
                                                        <input v-model="business.metadata.references.supplier_return" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Reference" max="50">
                                                    </div>
                                                </div>

                                            </div>
                                                
                                                <div class="mb-3">
                                                    <button class="btn  btn-success"  style="width:100%" :disabled="loading" @click="save()"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('save')}}</button>
                                                </div>

                                        </div> -->

                                        <!-- template builder with inner tabs -->
                                        <div v-if="step == 'templates'" class="show fade" id="list-home" role="tabpanel" aria-labelledby="list-home-list">
                                            <!-- Inner tabs for Templates | Pos Templates | Membership Card -->
                                            <ul class="nav nav-tabs mb-3">
                                                <li class="nav-item d-none d-sm-block">
                                                    <button
                                                        style="padding:0.5rem!important"
                                                        class="flex-sm-fill text-sm-center nav-link"
                                                        :class="templateTab === 'invoice' ? 'active' : ''"
                                                        @click="templateTab = 'invoice'"
                                                    >{{ $t('documents') }}</button>
                                                </li>
                                                <li class="nav-item">
                                                    <button
                                                        style="padding:0.5rem!important"
                                                        class="flex-sm-fill text-sm-center nav-link"
                                                        :class="templateTab === 'pos' ? 'active' : ''"
                                                        @click="templateTab = 'pos'"
                                                    >{{ $t('pos_receipts') }}</button>
                                                </li>
                                                <li class="nav-item">
                                                    <button
                                                        style="padding:0.5rem!important"
                                                        class="flex-sm-fill text-sm-center nav-link"
                                                        :class="templateTab === 'membership_card' ? 'active' : ''"
                                                        @click="templateTab = 'membership_card'"
                                                    >
                                                        {{ $t('membership_card') }}
                                                    </button>
                                                </li>
                                            </ul>

                                            <div class="row mb-2" v-if="templateTab === 'invoice'">
                                                <invoice-template-builder @templateSaved="getTemplates"></invoice-template-builder>
                                            </div>
                                            <div class="row mb-2" v-else-if="templateTab === 'pos'">
                                                <pos-receipt-template-builder></pos-receipt-template-builder>
                                            </div>
                                            <div class="row mb-2" v-else-if="templateTab === 'membership_card'">
                                                <membership-card-template-builder 
                                                    ref="membershipCardBuilder"
                                                    :template_id="membershipCardTemplateId" 
                                                    :template="membershipCardTemplate"
                                                    @templateSaved="onMembershipCardTemplateSaved"
                                                    @templateDeleted="onMembershipCardTemplateDeleted"
                                                ></membership-card-template-builder>
                                            </div>
                                        </div>

                                        <!-- module builder -->
                                        <div v-if="step == 'modules'" class="container show fade" id="list-home" role="tabpanel" aria-labelledby="list-home-list">
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <!-- xoxovi Style Top Search/Filter Bar -->
                                                    <div class="xoxovi-apps-controls mb-4 p-3 bg-white rounded-3 shadow-sm d-flex align-items-center justify-content-between flex-wrap gap-3">
                                                        <div class="search-container position-relative flex-grow-1" style="max-width: 500px;">
                                                            <AppIcon name="bi-search" class="bi bi-search position-absolute start-0 top-50 translate-middle-y ms-3 text-muted" />
                                                            <input type="text" v-model="searchQuery" class="form-control border-0 bg-light rounded-2" :placeholder="$t('search_apps')" style="height: 40px; font-size: 14px; padding-left: 34px !important;">
                                                        </div>
                                                        
                                                        <div class="d-flex align-items-center gap-2 overflow-auto no-scrollbar py-1 filter-scroll-container">
                                                            <div class="btn-group rounded-2 overflow-hidden shadow-sm flex-nowrap" role="group">
                                                                <button v-for="cat in categories" :key="cat.id"
                                                                    class="btn btn-sm px-3 py-2 border-0 fw-bold transition-all text-nowrap"
                                                                    :style="activeCategory === cat.id ? { backgroundColor: '#4A4A4A', color: '#fff' } : { backgroundColor: '#fff', color: '#666' }"
                                                                    @click="activeCategory = cat.id"
                                                                    style="font-size: 11px; height: 38px; min-width: max-content;">
                                                                    {{$t(cat.title)}}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Empty State -->
                                                    <div v-if="filteredModules.length === 0" class="text-center py-5">
                                                        <div class="display-1 text-light mb-3"><AppIcon name="bi-regex" class="bi bi-regex" /></div>
                                                        <h5 class="text-secondary fw-bold">{{$t('no_results_found')}}</h5>
                                                        <p class="text-muted small">{{$t('try_adjusting_your_search_or_filter')}}</p>
                                                        <button class="btn btn-sm btn-link text-dark fw-bold text-decoration-none" @click="searchQuery = ''; activeCategory = 'all'">{{$t('clear_all_filters')}}</button>
                                                    </div>

                                                    <!-- Apps Grid (xoxovi Style) -->
                                                    <div v-if="filteredModules.length > 0" class="row g-3">
                                                        <div v-for="(module, index) in filteredModules" :key="'module-' + index" 
                                                            class="col-12 col-md-6 col-lg-4 col-xl-4">
                                                            <div class="xoxovi-app-card h-100 bg-white rounded-3 shadow-sm d-flex flex-column transition-all border position-relative"
                                                                :class="{ 
                                                                    'active-app-shadow': isModuleEnabled(module) && module.module_key !== 'settings',
                                                                    'deactivated-module': !isModuleEnabled(module) && module.module_key !== 'settings',
                                                                    'plan-locked-module': !isModuleEligible(module)
                                                                }">
                                                                <!-- Top-left: Installed / Pro tag ribbon -->
                                                                <div class="position-absolute top-0 start-0 overflow-hidden" style="width: 72px; height: 72px; border-radius: 12px 0 0 0; pointer-events: none; z-index: 1;">
                                                                    <div v-if="isModuleEnabled(module)"
                                                                        style="
                                                                            position: absolute;
                                                                            top: 10px;
                                                                            left: -22px;
                                                                            width: 80px;
                                                                            background: #198754;
                                                                            color: #fff;
                                                                            font-size: 7px;
                                                                            font-weight: 700;
                                                                            text-align: center;
                                                                            padding: 3px 0;
                                                                            transform: rotate(-45deg);
                                                                            text-transform: uppercase;
                                                                            box-shadow: 0 1px 4px rgba(0,0,0,0.15);
                                                                        ">
                                                                        ✓ {{$t('installed')}}
                                                                    </div>
                                                                    <div v-else-if="!isModuleEligible(module)"
                                                                        style="
                                                                            position: absolute;
                                                                            top: 10px;
                                                                            left: -22px;
                                                                            width: 80px;
                                                                            background: #dc3545;
                                                                            color: #fff;
                                                                            font-size: 7px;
                                                                            font-weight: 700;
                                                                            text-align: center;
                                                                            padding: 3px 0;
                                                                            transform: rotate(-45deg);
                                                                            text-transform: uppercase;
                                                                            box-shadow: 0 1px 4px rgba(0,0,0,0.15);
                                                                        ">
                                                                        🔒 {{$t('pro')}}
                                                                    </div>
                                                                </div>
                                                                <!-- Top-right: Gear settings button -->
                                                                <div class="position-absolute top-0 end-0 p-2 d-flex gap-2">
                                                                    <button v-if="hasModuleSettings(module) && isModuleEnabled(module)" 
                                                                        class="btn btn-link btn-sm text-secondary p-0 hover-black transition-all"
                                                                        @click="openModuleSettings(module)"
                                                                        :title="$t('settings')">
                                                                        <AppIcon name="bi-gear-fill" class="bi bi-gear-fill" />
                                                                    </button>

                                                                </div>
                                                                <div class="p-3 pt-5 d-flex align-items-start gap-3">
                                                                    <div class="app-icon-container flex-shrink-0 d-flex align-items-center justify-content-center rounded-2 shadow-sm"
                                                                        :style="{ 
                                                                            width: '56px', height: '56px', 
                                                                            backgroundColor: getModuleColor(module.module_key),
                                                                            color: '#fff',
                                                                            fontSize: '28px'
                                                                        }">
                                                                        <AppIcon :name="module.icon" :class="module.icon" />
                                                                    </div>
                                                                    <div class="flex-grow-1 min-width-0">
                                                                        <h6 class="mb-0 fw-bold text-truncate" :title="$t(module.title)">{{ $t(module.title) }}</h6>
                                                                        <div class="text-muted small mt-1" :style="{ fontSize: '11px', lineHeight: '1.4' }">
                                                                            {{ $t(module.description || '') }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                
                                                                <div class="card-footer mt-auto bg-white border-0 p-3 pt-0 d-flex align-items-center justify-content-between gap-2">
                                                                    <button
                                                                        v-if="module.module_key !== 'settings' && module.items && module.items.length > 1"
                                                                        :id="`module-expand-${module.id || module.module_key}`"
                                                                        type="button"
                                                                        class="btn btn-sm btn-light border rounded-circle d-inline-flex align-items-center justify-content-center module-expand-button"
                                                                        :disabled="!isModuleEligible(module) || !isModuleEnabled(module)"
                                                                        :title="module.expanded ? $t('collapse') : $t('expand')"
                                                                        :aria-label="module.expanded ? $t('collapse') : $t('expand')"
                                                                        :aria-pressed="module.expanded ? 'true' : 'false'"
                                                                        @click="module.expanded = !module.expanded"
                                                                    >
                                                                        <AppIcon :name="module.expanded ? 'bi bi-arrows-collapse' : 'bi bi-arrows-expand'" :class="module.expanded ? 'bi bi-arrows-collapse' : 'bi bi-arrows-expand'" aria-hidden="true" />
                                                                    </button>
                                                                    <div class="app-actions">
                                                                        <button v-if="!isModuleEligible(module)" 
                                                                            @click="goToUpgrade(module)"
                                                                            class="btn btn-sm btn-dark rounded-1 px-3 py-1 fw-bold" style="font-size: 11px;">
                                                                            {{ $t('upgrade') }}
                                                                        </button>
                                                                        <button v-else-if="module.module_key === 'settings'"
                                                                            class="btn btn-sm btn-light border rounded-1 px-3 py-1 fw-bold disabled" style="font-size: 11px;">
                                                                            {{ $t('core') }}
                                                                        </button>
                                                                        <button v-else
                                                                            @click="toggleModule(module)"
                                                                            class="btn rounded-1 px-4 py-2 fw-bold transition-all shadow-sm"
                                                                            :class="isModuleEnabled(module) ? 'btn-outline-danger' : 'btn-dark'"
                                                                            style="font-size: 13px;">
                                                                            {{ isModuleEnabled(module) ? $t('deactivate') : $t('activate') }}
                                                                        </button>
                                                                    </div>
                                                                </div>

                                                                <div v-if="module.items && module.items.length > 0" class="border-top p-2 bg-light d-flex flex-wrap gap-1 module-items-panel" style="border-top: 1px solid rgba(0,0,0,0.05) !important;">
                                                                    <label v-for="(item, itemIndex) in module.items" :key="itemIndex"
                                                                        class="badge rounded-pill fw-medium px-2 py-1 shadow-sm transition-all m-0 border hover-pop d-inline-flex align-items-center gap-1 bg-white text-dark"
                                                                        :class="{ 'module-item-upgrade-locked': !isModuleItemEligible(module, item) }"
                                                                        style="font-size: 0.65rem; cursor: pointer;">
                                                                        <input type="checkbox" class="d-none" v-model="item.enabled" :disabled="module.module_key === 'settings' || !isModuleItemEligible(module, item)">
                                                                        <AppIcon name="bi-lock-fill" v-if="!isModuleItemEligible(module, item)" class="bi bi-lock-fill text-primary" style="font-size: 0.75rem;" />
                                                                        <AppIcon name="bi-toggle-on" v-else :class="item.enabled ? 'bi bi-toggle-on text-success' : 'bi bi-toggle-off text-secondary'" style="font-size: 0.85rem;" />
                                                                        {{ $t(item.title) }}
                                                                        <span v-if="!isModuleItemEligible(module, item)" class="ms-1 text-primary">Upgrade</span>
                                                                    </label>
                                                                </div>
                                                                <div v-if="!isModuleEligible(module)" class="module-upgrade-overlay">
                                                                    <div class="module-upgrade-content">
                                                                        <span class="module-upgrade-icon">
                                                                            <AppIcon name="bi-lock-fill" class="bi bi-lock-fill" />
                                                                        </span>
                                                                        <strong>Upgrade requis</strong>
                                                                        <small>Ce module n’est pas inclus dans votre plan {{ currentPricingPlan.name }}.</small>
                                                                        <button class="btn btn-sm btn-primary" @click="goToUpgrade(module)">
                                                                            Voir les plans
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Global Save Bar -->
                                                        <button class="mt-3 btn btn-success btn-lg w-100 shadow rounded-pill py-3 fw-bold ripple" 
                                                            :disabled="loading" @click="saveSidebarSettings">
                                                            <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                            <AppIcon name="bi-check2-circle" v-else class="bi bi-check2-circle me-2 fs-5" />
                                                            {{$t('save_module_configuration')}}
                                                        </button>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Sticky Save Button (xoxovi Style) -->
                                        <transition name="fade-up">
                                            <div v-if="isDirty && (step === 'modules' || step === 'business')" class="position-fixed bottom-0 start-50 translate-middle-x mb-4" style="z-index: 1050;">
                                                <button 
                                                    class="btn btn-success btn-lg rounded-pill shadow-lg px-5 py-3 d-flex align-items-center fw-bold transition-all hover-pop border-0 ripple" 
                                                    :disabled="loading" 
                                                    @click="step === 'modules' ? saveSidebarSettings() : save()">
                                                    <span v-if="loading" class="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                                                    <AppIcon name="bi-cloud-arrow-up-fill" v-else class="bi bi-cloud-arrow-up-fill me-3 fs-3" />
                                                    {{ step === 'modules' ? $t('save_module_configuration') : $t('save_settings') }}
                                                </button>
                                            </div>
                                        </transition>

                                         <!-- integrations -->
                                        <div v-if="step == 'integrations'" class="show fade" id="list-home" role="tabpanel" aria-labelledby="list-home-list">
                                            <div class="container">
                                                <developer-integrations />
                                                <template v-if="showLegacyIntegrations">
                                                <hr class="my-5"/>
                                                <div class="row">
                                                    <div class="col-12">
                                                        <h5 class="mb-4">{{$t('email_integration')}}</h5>
                                                        
                                                        <!-- Email Integration Card -->
                                                        <div class="card mb-4">
                                                            <div class="card-header d-flex justify-content-between align-items-center">
                                                                <div>
                                                                    <AppIcon name="bi-envelope" class="bi bi-envelope me-2" />
                                                                    <strong>Gmail Integration</strong>
                                                                </div>
                                                                <div class="form-check form-switch">
                                                                    <input class="form-check-input" 
                                                                        type="checkbox" 
                                                                        :id="'email-toggle'" 
                                                                        v-model="emailIntegration.enabled"
                                                                        @change="toggleEmailIntegration">
                                                                    <label class="form-check-label" :for="'email-toggle'">
                                                                        {{ emailIntegration.enabled ? $t('enabled') : $t('disabled') }}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div class="card-body">
                                                                <div v-if="emailIntegration.enabled">
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <div class="mb-3">
                                                                                <label class="form-label">{{$t('email_address')}}</label>
                                                                                <input type="email" 
                                                                                    v-model="emailIntegration.settings.auth.user" 
                                                                                    class="form-control" 
                                                                                    :placeholder="$t('your_email@gmail.com')">
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <div class="mb-3">
                                                                                <label class="form-label">{{$t('app_password')}}</label>
                                                                                <input type="password" 
                                                                                    v-model="emailIntegration.settings.auth.pass" 
                                                                                    class="form-control" 
                                                                                    :placeholder="$t('your_app_password')">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    
                                                                    <!-- Setup Instructions -->
                                                                    <div class="alert alert-info">
                                                                        <h6><AppIcon name="bi-info-circle" class="bi bi-info-circle me-2" />{{$t('setup_instructions')}}</h6>
                                                                        <ol class="mb-0">
                                                                            <li>{{$t('step_1_gmail')}}</li>
                                                                            <li>{{$t('step_2_2fa')}}</li>
                                                                            <li>{{$t('step_3_app_password')}} <a href="https://myaccount.google.com/apppasswords" target="_blank" class="alert-link">{{$t('generate_app_password')}}</a></li>
                                                                            <li>{{$t('step_4_use_app_password')}}</li>
                                                                        </ol>
                                                                    </div>
                                                                    
                                                                    <!-- Test Email Section -->
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <div class="mb-3">
                                                                                <label class="form-label">{{$t('test_email_address')}}</label>
                                                                                <input type="email" 
                                                                                    v-model="testEmailAddress" 
                                                                                    class="form-control" 
                                                                                    :placeholder="$t('test_email_placeholder')">
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-6 d-flex align-items-center" style="margin-top:1rem">
                                                                            <button class="btn btn-outline-primary" 
                                                                                @click="testEmailIntegration"
                                                                                :disabled="!testEmailAddress || testingEmail">
                                                                                <AppIcon name="bi-send" class="bi bi-send me-2" />
                                                                                {{ testingEmail ? $t('sending') : $t('send_test_email') }}
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    
                                                                    <div class="d-flex justify-content-end">
                                                                        <button class="btn btn-success" 
                                                                            @click="saveEmailIntegration"
                                                                            :disabled="savingIntegration">
                                                                            <AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />
                                                                            {{ savingIntegration ? $t('saving') : $t('save') }}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div v-else>
                                                                    <p class="text-muted mb-0">{{$t('email_integration_disabled')}}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr class="my-4"/>
                                                <div class="row">
                                                    <div class="col-12">
                                                        <h5 class="mb-4">Printer Integration</h5>
                                                        <div class="card mb-4">
                                                            <div class="card-header d-flex justify-content-between align-items-center">
                                                                <div>
                                                                    <AppIcon name="bi-printer" class="bi bi-printer me-2" />
                                                                    <strong>IPP/HTTP Printer</strong>
                                                                </div>
                                                                <div class="form-check form-switch">
                                                                    <input class="form-check-input"
                                                                        type="checkbox"
                                                                        :id="'printer-toggle'"
                                                                        v-model="printerIntegration.enabled"
                                                                        @change="togglePrinterIntegration">
                                                                    <label class="form-check-label" :for="'printer-toggle'">
                                                                        {{ printerIntegration.enabled ? $t('enabled') : $t('disabled') }}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div class="card-body">
                                                                <div v-if="printerIntegration.enabled">
                                                                    <div class="row">
                                                                        <div class="col-md-8">
                                                                            <div class="mb-3">
                                                                                <label class="form-label">Printer URL</label>
                                                                                <input type="text"
                                                                                    v-model="printerIntegration.settings.url"
                                                                                    class="form-control"
                                                                                    placeholder="ipp://192.168.1.50:631/ipp/print or http://printer.local:631/ipp/print">
                                                                                <small class="text-muted">Use a reachable IPP URL. Example: ipp://&lt;printer-ip&gt;:631/ipp/print</small>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-md-4 d-flex align-items-center">
                                                                            <button class="btn btn-outline-secondary w-100" @click="testPrinter" :disabled="testingPrinter">
                                                                                <AppIcon name="bi-printer" class="bi bi-printer me-2" />{{ testingPrinter ? $t('saving') : 'Test Print' }}
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <div class="d-flex justify-content-end">
                                                                        <button class="btn btn-success" @click="savePrinterIntegration" :disabled="savingIntegration">
                                                                            <AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{ savingIntegration ? $t('saving') : $t('save_integration') }}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div v-else>
                                                                    <p class="text-muted mb-0">Printer integration disabled</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                </template>
                                            </div>
                                        </div>

                                        <!-- billing -->
                                        <div v-if="step == 'billing'" class="show fade" id="list-home" role="tabpanel" aria-labelledby="list-home-list">
                                            <div class="container">
                                                <div class="current-plan-card mb-4">
                                                    <div class="current-plan-head">
                                                        <div>
                                                            <span class="current-plan-kicker">Plan actuel</span>
                                                            <h5>{{ currentPricingPlan.name }}</h5>
                                                            <p>{{ currentPricingPlan.description }}</p>
                                                        </div>
                                                        <div class="current-plan-price">
                                                            <span v-if="currentPricingPlan.enterprise">Sur devis</span>
                                                            <template v-else>
                                                                <strong>{{ formatPlanAmount(currentPricingPlan.monthly) }} DH HT</strong>
                                                                <small>/ mois</small>
                                                            </template>
                                                        </div>
                                                    </div>

                                                    <div class="current-plan-actions">
                                                        <button class="btn btn-primary btn-sm" @click="$router.push({ path: '/subscribe', query: { plan: currentPricingPlan.key || currentPricingPlan.id } })">
                                                            Changer de plan
                                                        </button>
                                                    </div>

                                                    <div class="subscription-period">
                                                        <div class="subscription-period-item">
                                                            <span>{{ $t('start_date') }}</span>
                                                            <strong>{{ formatBillingDate(billingSubscription && billingSubscription.start_date) }}</strong>
                                                        </div>
                                                        <div class="subscription-period-item">
                                                            <span>{{ $t('end_date') }}</span>
                                                            <strong>{{ formatBillingDate(billingSubscription && billingSubscription.end_date) }}</strong>
                                                        </div>
                                                        <div class="subscription-period-item">
                                                            <span>{{ $t('status') }}</span>
                                                            <strong class="text-capitalize">{{ (billingSubscription && billingSubscription.status) || '-' }}</strong>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="billing-invoices-card">
                                                    <div class="billing-invoices-head">
                                                        <div>
                                                            <h6>{{ $t('subscription_invoices') }}</h6>
                                                            <p>{{ $t('subscription_invoices_description') }}</p>
                                                        </div>
                                                        <span class="invoice-count">{{ billingInvoices.length }}</span>
                                                    </div>

                                                    <div v-if="billingLoading" class="billing-empty-state">
                                                        {{ $t('loading') }}...
                                                    </div>
                                                    <div v-else-if="!billingInvoices.length" class="billing-empty-state">
                                                        <AppIcon name="bi-receipt" class="bi bi-receipt" />
                                                        <span>{{ $t('no_subscription_invoices') }}</span>
                                                    </div>
                                                    <div v-else class="billing-invoice-list">
                                                        <div v-for="invoice in billingInvoices" :key="invoice.id" class="billing-invoice-row">
                                                            <div class="billing-invoice-icon"><AppIcon name="bi-file-earmark-pdf" class="bi bi-file-earmark-pdf" /></div>
                                                            <div class="billing-invoice-details">
                                                                <strong>{{ invoice.invoice_number || invoice.file_name }}</strong>
                                                                <span>
                                                                    {{ formatBillingDate(invoice.invoice_date) }}
                                                                    <template v-if="invoice.amount !== null && invoice.amount !== undefined"> · {{ formatPlanAmount(invoice.amount) }} {{ business.currency || 'DH' }}</template>
                                                                </span>
                                                            </div>
                                                            <button class="btn btn-outline-primary btn-sm" :disabled="invoiceDownloading === invoice.id" @click="downloadBillingInvoice(invoice)">
                                                                <AppIcon name="bi-download" class="bi bi-download me-1" />
                                                                {{ invoiceDownloading === invoice.id ? $t('loading') : $t('download') }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- advanced settings -->
                                        <div v-if="step == 'advanced'" class="show fade" id="list-advanced" role="tabpanel" aria-labelledby="list-advanced-list">
                                            <div class="container">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <!-- <div class="card">
                                                            <div class="card-body">
                                                                <div class="d-flex align-items-center justify-content-between">
                                                                    <div>
                                                                        <h6 class="mb-1">Price includes taxes</h6>
                                                                        <p class="text-muted mb-0 small">If enabled, product prices are tax-inclusive.</p>
                                                                    </div>
                                                                    <div class="form-check form-switch">
                                                                        <input class="form-check-input" type="checkbox" id="toggle-price-includes-tax" v-model="priceIncludesTax" style="cursor:pointer">
                                                                        <label class="form-check-label" for="toggle-price-includes-tax">{{ priceIncludesTax ? $t('enabled') : $t('disabled') }}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> -->

                                                        <div class="card mt-4" v-if="role == 'owner'">
                                                            <div class="card-body">
                                                                <div class="d-flex align-items-center justify-content-between">
                                                                    <div>
                                                                        <h6 class="mb-1">Application Logs</h6>
                                                                        <p class="text-muted mb-0 small">You can see detailed application logs for troubleshooting and auditing by clicking the link below.</p>
                                                                        <router-link class="p-3 d-flex align-items-center" style="padding:0 !important" to="/logs">
                                                                            <b>{{$t('logs')}}</b>
                                                                        </router-link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                         <div v-if="step == 'security' && role == 'owner'" class="show fade" id="list-security" role="tabpanel">
                                            <div class="container">
                                                <div class=" row">
                                                    <div class="col-12">
                                                        <h5 class="mb-4">{{$t('two_factor_authentication')}}</h5>
                                                        
                                                        <!-- 2FA Card -->
                                                        <div v-if="role == 'owner'" class="card mb-4">
                                                            <div class="card-header d-flex justify-content-between align-items-center">
                                                                <div>
                                                                    <AppIcon name="bi-shield-lock" class="bi bi-shield-lock me-2" />
                                                                    <strong>{{$t('authenticator_app')}}</strong>
                                                                </div>
                                                                <div class="form-check form-switch">
                                                                    <input class="form-check-input" 
                                                                        type="checkbox" 
                                                                        id="toggle-2fa" 
                                                                        :checked="currentUser.two_factor_enabled" 
                                                                        @change="toggle2FA">
                                                                    <label class="form-check-label" for="toggle-2fa">
                                                                        {{ currentUser.two_factor_enabled ? $t('enabled') : $t('disabled') }}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div class="card-body">
                                                                <p class="text-muted mb-3">{{$t('use_authenticator_app_desc')}}</p>
                                                                
                                                                <!-- Setup Section -->
                                                                <div v-if="show2FASetup">
                                                                    <div class="row">
                                                                        <div class="col-md-4 text-center">
                                                                            <img :src="qrCodeUrl" alt="QR Code" class="img-fluid mb-2" style="max-width: 200px; border: 1px solid #e9ecef; border-radius: 8px; padding: 10px;">
                                                                        </div>
                                                                        <div class="col-md-8">
                                                                            <h6 class="mb-3">{{$t('setup_instructions')}}</h6>
                                                                            <ol class="mb-3">
                                                                                <li class="mb-2">{{$t('install_authenticator_app')}}</li>
                                                                                <li class="mb-2">{{$t('scan_qr_code')}}</li>
                                                                                <li class="mb-2">{{$t('enter_code_below')}}</li>
                                                                            </ol>
                                                                            <div class="mb-3">
                                                                                <label class="form-label">{{$t('verification_code')}}</label>
                                                                                <input type="text" 
                                                                                    class="form-control" 
                                                                                    v-model="otpCode" 
                                                                                    :placeholder="$t('enter_6_digit_code')" 
                                                                                    maxlength="6">
                                                                            </div>
                                                                            <div class="d-flex justify-content-end">
                                                                                <button class="btn btn-success" 
                                                                                    @click="verifyAndEnable2FA" 
                                                                                    :disabled="!otpCode || verifying2FA">
                                                                                    <AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />
                                                                                    {{ verifying2FA ? $t('verifying') : $t('verify_and_enable') }}
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div v-else-if="!currentUser.two_factor_enabled">
                                                                    <p class="text-muted mb-0">{{$t('2fa_disabled_message')}}</p>
                                                                </div>
                                                                <div v-else>
                                                                    <div class="alert alert-success mb-0">
                                                                        <AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />
                                                                        {{$t('2fa_enabled_message')}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <!-- Active Sessions Card -->
                                                        <div class="card mb-4">
                                                            <div class="card-header">
                                                                <div>
                                                                    <AppIcon name="bi-laptop" class="bi bi-laptop me-2" />
                                                                    <strong>{{$t('active_sessions')}}</strong>
                                                                </div>
                                                            </div>
                                                            <div class="card-body">
                                                                <div class="table-responsive">
                                                                    <table class="table table-hover">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>{{$t('device')}}</th>
                                                                                <th>{{$t('ip_address')}}</th>
                                                                                <th>{{$t('created_at')}}</th>
                                                                                <th>{{$t('action')}}</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="token in refreshTokens" :key="token.id">
                                                                                <td>
                                                                                    <div class="d-flex align-items-center">
                                                                                        <AppIcon name="bi-phone" class="bi bi-phone me-2" v-if="token.parsedUserAgent.includes('Mobile')" />
                                                                                        <AppIcon name="bi-laptop" class="bi bi-laptop me-2" v-else />
                                                                                        {{ token.parsedUserAgent }}
                                                                                        <span v-if="token.is_current" class="badge bg-success ms-2 mt-1" style="font-size: 10px; font-weight: 500;">{{$t('current')}}</span>
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    <div class="d-flex align-items-center">
                                                                                        <span class="me-2">{{ token.showIp ? token.ip_address : '***.***.***.***' }}</span>
                                                                                        <AppIcon :name="token.showIp ? 'bi-eye-slash' : 'bi-eye'" class="bi" :class="token.showIp ? 'bi-eye-slash' : 'bi-eye'" style="cursor: pointer;" @click="token.showIp = !token.showIp" />
                                                                                    </div>
                                                                                </td>
                                                                                <td>{{ formatDateFromNow(token.created_at) }}</td>
                                                                                <td>
                                                                                    <button class="btn btn-sm btn-outline-danger py-1 px-2" style="font-size: 12px;" @click="revokeRefreshToken(token.id)">
                                                                                        {{$t('revoke')}}
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                            <tr v-if="refreshTokens.length === 0">
                                                                                <td colspan="4" class="text-center">{{$t('no_active_sessions')}}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </div>

                                </div>
                            </div>
                           
                        </div>

                                        <!-- security settings -->
                                       
                </div>
            </section>


        <!-- Create Modal -->
        <div  class="modal fade" id="show-advanced-modal" tabindex="-1" aria-labelledby="show-advanced-modal" aria-hidden="true">
            <div class="modal-dialog modal-lg">

                <div class="modal-content">
                    
                <div v-if="createModalisOpen" class="modal-body" style="text-align:left">
                    

                    <h6>{{$t('custom_fields')}}</h6>

                        <table class="table mb-0 table-borderless table-striped small">
                            <thead>
                                <tr class="text-secondary">
                                    <th class="pt-4 pb-3 px-6">{{$t('field_name')}}</th>
                                    <th class="pt-4 pb-3 px-6">{{$t('field_value')}}</th>
                                    <th class="pt-4 pb-3 px-6">{{$t('action')}}</th>
                                </tr>
                            </thead>
                            <tbody>

                            <tr v-for="(value,key) in business.extra_fields" :key="key">
                                <td class=" px-6"><input type="string" class="form-control" v-model="business.extra_fields[key].field_name" ></td>
                                <td class=" px-6"><input type="string" class="form-control" v-model="business.extra_fields[key].field_value"></td>
                                <td class=" px-6" style="text-align: center;padding-top: 5px !important;">
                                    <button @click="removeField(key)" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-danger btn-xs">
                                        <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
                                    </button>
                                </td>
                            </tr>
                            <button class="btn btn-success btn-sm m-2" @click="addNewField">+</button>

                            </tbody>
                        </table>
                   
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                        <button type="button" class="btn btn-success" @click="saveFields"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('save')}}</button>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <!-- Create modal -->

        <!-- Module Settings Modal -->
        <div class="modal fade" id="module-settings-modal" tabindex="-1" aria-labelledby="module-settings-modal-label" aria-hidden="true">
            <div class="modal-dialog modal-fullscreen">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="module-settings-modal-label">
                            <AppIcon :name="currentModule?.icon" :class="currentModule?.icon" class="me-2" />
                            {{ currentModule ? $t(currentModule.title) : '' }} - {{ $t('settings') }}
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body d-flex flex-column flex-grow-1 p-0 overflow-hidden" style="min-height: 0;">
                        <!-- Dashboard Settings -->
                        <!-- Dashboard Settings -->
                        <div v-if="currentModule?.module_key === 'dashboard'" class="d-flex h-100" style="min-height: 70vh;">
                            <div class="settings-sidebar d-flex flex-column flex-shrink-0" style="width: 200px;">
                                <ul class="nav settings-sidebar-nav flex-column mb-auto">
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeDashboardTab === 'general' }" @click.prevent="activeDashboardTab = 'general'">
                                            <AppIcon name="bi-gear" class="bi bi-gear me-3" />
                                            {{ $t('general') }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="flex-grow-1 overflow-auto p-4">
                                <dashboard-settings :active-tab="activeDashboardTab" />
                            </div>
                        </div>

                        <!-- Subscription Management Settings -->
                        <!-- Subscription Management Settings -->
                        <div v-else-if="currentModule?.module_key === 'subscription_management'" class="d-flex h-100" style="min-height: 70vh;">
                            <div class="settings-sidebar d-flex flex-column flex-shrink-0" style="width: 200px;">
                                <ul class="nav settings-sidebar-nav flex-column mb-auto">
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeSubscriptionTab === 'membership_card' }" @click.prevent="activeSubscriptionTab = 'membership_card'">
                                            <AppIcon name="bi-credit-card" class="bi bi-credit-card me-3" />
                                            {{ $t('membership_card') }}
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeSubscriptionTab === 'general' }" @click.prevent="activeSubscriptionTab = 'general'">
                                            <AppIcon name="bi-gear" class="bi bi-gear me-3" />
                                            {{ $t('general_settings') }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="flex-grow-1 overflow-auto p-4">
                                <subscription-settings 
                                    ref="subscriptionSettings"
                                    :active-tab="activeSubscriptionTab"
                                    @templateSaved="onMembershipCardTemplateSaved"
                                    @templateDeleted="onMembershipCardTemplateDeleted"
                                />
                            </div>
                        </div>

                        <!-- POS Settings -->
                        <div v-else-if="currentModule?.module_key === 'pos'" class="d-flex h-100" style="min-height: 70vh;">
                            <div class="settings-sidebar d-flex flex-column flex-shrink-0" style="width: 200px;">
                                <ul class="nav settings-sidebar-nav flex-column mb-auto">
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activePosTab === 'template' }" @click.prevent="activePosTab = 'template'">
                                            <AppIcon name="bi-file-earmark-text" class="bi bi-file-earmark-text me-3" />
                                            {{ $t('receipt_template') }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="flex-grow-1 overflow-auto p-4">
                                <pos-receipt-template-builder v-if="activePosTab === 'template'" />
                            </div>
                        </div>

                        <!-- Sales Settings -->
                        <!-- Sales Settings -->
                        <div v-else-if="currentModule?.module_key === 'sales'" class="d-flex h-100" style="min-height: 70vh;">
                            <div class="settings-sidebar d-flex flex-column flex-shrink-0" style="width: 200px;">
                                <ul class="nav settings-sidebar-nav flex-column mb-auto">
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeSalesTab === 'general' }" @click.prevent="activeSalesTab = 'general'">
                                            <AppIcon name="bi-gear" class="bi bi-gear me-3" />
                                            {{ $t('general') }}
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeSalesTab === 'template' }" @click.prevent="activeSalesTab = 'template'">
                                            <AppIcon name="bi-file-earmark-text" class="bi bi-file-earmark-text me-3" />
                                            {{ $t('template') }}
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeSalesTab === 'suggestions' }" @click.prevent="activeSalesTab = 'suggestions'">
                                            <AppIcon name="bi-chat-square-text" class="bi bi-chat-square-text me-3" />
                                            {{ $t('suggestions') }}
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeSalesTab === 'reference_builder' }" @click.prevent="activeSalesTab = 'reference_builder'">
                                            <AppIcon name="bi-hash" class="bi bi-hash me-3" />
                                            {{ $t('reference_builder') }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="flex-grow-1 overflow-auto">
                                <sales-settings :active-tab="activeSalesTab" module-name="sales" @templateSaved="getTemplates" />
                            </div>
                        </div>

                        <!-- CRM Settings -->
                        <div v-else-if="currentModule?.module_key === 'crm'" class="d-flex h-100" style="min-height: 70vh;">
                            <div class="settings-sidebar d-flex flex-column flex-shrink-0" style="width: 200px;">
                                <ul class="nav settings-sidebar-nav flex-column mb-auto">
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeCrmTab === 'clients' }" @click.prevent="activeCrmTab = 'clients'">
                                            <AppIcon name="bi-people" class="bi bi-people me-3" />
                                            {{ $t('clients') }}
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeCrmTab === 'suppliers' }" @click.prevent="activeCrmTab = 'suppliers'">
                                            <AppIcon name="bi-truck" class="bi bi-truck me-3" />
                                            {{ $t('suppliers') }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="flex-grow-1 overflow-auto p-4">
                                <crm-settings :active-tab="activeCrmTab" />
                            </div>
                        </div>

                        <!-- Purchase Settings -->
                        <!-- Purchase Settings -->
                        <div v-else-if="currentModule?.module_key === 'purchases'" class="d-flex h-100" style="min-height: 70vh;">
                            <div class="settings-sidebar d-flex flex-column flex-shrink-0" style="width: 200px;">
                                <ul class="nav settings-sidebar-nav flex-column mb-auto">
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activePurchaseTab === 'general' }" @click.prevent="activePurchaseTab = 'general'">
                                            <AppIcon name="bi-gear" class="bi bi-gear me-3" />
                                            {{ $t('general') }}
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activePurchaseTab === 'template' }" @click.prevent="activePurchaseTab = 'template'">
                                            <AppIcon name="bi-file-earmark-text" class="bi bi-file-earmark-text me-3" />
                                            {{ $t('template') }}
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activePurchaseTab === 'reference_builder' }" @click.prevent="activePurchaseTab = 'reference_builder'">
                                            <AppIcon name="bi-hash" class="bi bi-hash me-3" />
                                            {{ $t('reference_builder') }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="flex-grow-1 overflow-auto">
                                <sales-settings :active-tab="activePurchaseTab" module-name="purchase" @templateSaved="getTemplates" />
                            </div>
                        </div>

                        <!-- Inventory Settings -->
                        <!-- Inventory Settings -->
                        <div v-else-if="currentModule?.module_key === 'inventory'" class="d-flex h-100" style="min-height: 70vh;">
                            <div class="settings-sidebar d-flex flex-column flex-shrink-0" style="width: 200px;">
                                <ul class="nav settings-sidebar-nav flex-column mb-auto">
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeInventoryTab === 'general' }" @click.prevent="activeInventoryTab = 'general'">
                                            <AppIcon name="bi-gear" class="bi bi-gear me-3" />
                                            {{ $t('general') }}
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeInventoryTab === 'columns' }" @click.prevent="activeInventoryTab = 'columns'">
                                            <AppIcon name="bi-table" class="bi bi-table me-3" />
                                            {{ $t('products_table_columns') }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="flex-grow-1 overflow-auto p-4">
                                <inventory-settings :active-tab="activeInventoryTab" />
                            </div>
                        </div>

                        <!-- Contract Settings -->
                        <div v-else-if="currentModule?.module_key === 'contracts'" class="contract-settings-layout d-flex h-100">
                            <div class="settings-sidebar contract-settings-sidebar d-flex flex-column flex-shrink-0">
                                <ul class="nav settings-sidebar-nav flex-column mb-auto">
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeContractTab === 'template' }" @click.prevent="activeContractTab = 'template'">
                                            <AppIcon name="bi-file-earmark-text" class="bi bi-file-earmark-text me-3" />
                                            {{ $t('templates') }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="contract-settings-panel flex-grow-1 overflow-auto">
                                <contract-settings :active-tab="activeContractTab" />
                            </div>
                        </div>


                        <!-- Leads Settings -->
                        <div v-else-if="currentModule?.module_key === 'leads'" class="d-flex h-100" style="min-height: 70vh;">
                            <div class="settings-sidebar d-flex flex-column flex-shrink-0" style="width: 200px;">
                                <ul class="nav settings-sidebar-nav flex-column mb-auto">
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeLeadTab === 'statuses' }" @click.prevent="activeLeadTab = 'statuses'">
                                            <AppIcon name="bi-tag" class="bi bi-tag me-3" />
                                            {{ $t('lead_statuses') }}
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeLeadTab === 'sources' }" @click.prevent="activeLeadTab = 'sources'">
                                            <AppIcon name="bi-signpost-split" class="bi bi-signpost-split me-3" />
                                            {{ $t('lead_sources') }}
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeLeadTab === 'columns' }" @click.prevent="activeLeadTab = 'columns'">
                                            <AppIcon name="bi-table" class="bi bi-table me-3" />
                                            {{ $t('columns') }}
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeLeadTab === 'rules' }" @click.prevent="activeLeadTab = 'rules'">
                                            <AppIcon name="bi-sliders" class="bi bi-sliders me-3" />
                                            {{ $t('lead_rules') }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="flex-grow-1 overflow-auto p-4">
                                <lead-settings :active-tab="activeLeadTab" />
                            </div>
                        </div>

                        <!-- Project Management Settings -->
                        <div v-else-if="currentModule?.module_key === 'project_management'" class="d-flex h-100" style="min-height: 70vh;">
                            <div class="settings-sidebar d-flex flex-column flex-shrink-0" style="width: 200px;">
                                <ul class="nav settings-sidebar-nav flex-column mb-auto">
                                    <li class="nav-item">
                                        <a href="#" class="nav-link" :class="{ active: activeProjectTab === 'task_statuses' }" @click.prevent="activeProjectTab = 'task_statuses'">
                                            <AppIcon name="bi-tag" class="bi bi-tag me-3" />
                                            {{ $t('task_statuses') }}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="flex-grow-1 overflow-auto p-4">
                                <project-management-settings :active-tab="activeProjectTab" />
                            </div>
                        </div>

                        <!-- Placeholder for other modules -->
                        <div v-else>
                            <div class="alert alert-info">
                                <AppIcon name="bi-info-circle" class="bi bi-info-circle me-2" />
                                {{ $t('module_settings_coming_soon') }}
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer" v-if="!['sales', 'purchases', 'pos'].includes(currentModule?.module_key)">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                            <AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{ $t('close') }}
                        </button>
                        <button 
                            v-if="!['subscription_management', 'pos', 'sales', 'purchases', 'inventory', 'crm', 'dashboard', 'contracts', 'leads', 'project_management'].includes(currentModule?.module_key)"
                            type="button" 
                            class="btn btn-success" 
                            @click="saveModuleSettings"
                        >
                            <AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{ $t('save') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- End Module Settings Modal -->

        <invoice-template-modal 
            v-if="invoicePreviewModalisOpen" 
            @modalClosed="invoicePreviewModalisOpen = false" 
            modalId="invoice-quote-modal-01" 
            :isModalOpen="invoicePreviewModalisOpen"  
            :data="item" 
            type="quote">
        </invoice-template-modal>

        <payment-methods-modal ref="paymentMethodsModal"></payment-methods-modal>

  </div>
</template>

<script>

import helper from '../../helper'
import axios from 'axios'
import InvoiceTemplateBuilder  from '../../components/InvoiceTemplateBuilder.vue'
import InvoiceTemplateModal from '../../components/invoiceLayout/InvoiceTemplateModal.vue';
import PosReceiptTemplateBuilder from '../../components/PosReceiptTemplateBuilder.vue'
import MembershipCardTemplateBuilder from '../../modules/subscriptions/MembershipCardTemplateBuilder.vue'
import SubscriptionSettings from '../../modules/subscriptions/SubscriptionSettings.vue'
import DashboardSettings from '../../modules/dashboard/DashboardSettings.vue'
import SalesSettings from '../../modules/sales/SalesSettings.vue'
import CrmSettings from '../../modules/crm/CrmSettings.vue'

import InventorySettings from '../../modules/inventory/InventorySettings.vue'
import ContractSettings from '../../modules/contracts/ContractSettings.vue'
import LeadSettings from '../../modules/leads/LeadSettings.vue'
import ProjectManagementSettings from '../../modules/project_management/ProjectManagementSettings.vue'
import PaymentMethodsModal from '../../components/PaymentMethodsModal.vue'
import DeveloperIntegrations from '../../components/DeveloperIntegrations.vue'
import { canPlanAccessModule, canPlanAccessModuleItem, getBusinessPlanKey, getBusinessPricingPlan } from '@/constants/pricingPlans'



export default {
  name: 'Settings',
  persistedFilterState: { key: 'settings-modules', fields: ['searchQuery', 'activeCategory'] },
  components : {
    InvoiceTemplateBuilder,
    PosReceiptTemplateBuilder,
    MembershipCardTemplateBuilder,
    SubscriptionSettings,
    DashboardSettings,
    SalesSettings,
    CrmSettings,

    InventorySettings,
    ContractSettings,
    LeadSettings,
    ProjectManagementSettings,

    InvoiceTemplateModal,
    PaymentMethodsModal,
    DeveloperIntegrations,


  },
  data(){
    return {
        step : 'business',
        templateTab: 'invoice',
        templates : [],
        loading : false,
        selected_template : null,
        template_id : null,
        membershipCardTemplateId: null,
        membershipCardTemplate: null,
        isModalOpen : false,
        loadingImage: false,
        loadingStamp: false,
        hoverLogo: false,
        hoverStamp: false,
        createModal : null,
        createModalisOpen : false,
        invoicePreviewModalisOpen : false,

        modules : [],
        viewMode: 'list', // 'list' or 'grid'
        searchQuery: '',
        activeCategory: 'all',
        categories: [
            { id: 'all', title: 'all' },
            { id: 'operations', title: 'operations' },
            { id: 'crm', title: 'growth_crm' },
            { id: 'planning', title: 'hr_planning' },
            { id: 'finance', title: 'finance' },
            { id: 'system', title: 'system' }
        ],
        isDirty: false,
        initialModulesLoaded: false,
        initialSettingsLoaded: false,
        emailIntegration: {
            enabled: false,
            settings: {
                service: 'gmail',
                auth: {
                    user: '',
                    pass: ''
                }
            }
        },
        testEmailAddress: '',
        testingEmail: false,
        savingIntegration: false,
        showLegacyIntegrations: false,
        printerIntegration: {
            enabled: false,
            settings: {
                url: ''
            }
        },
        testingPrinter: false,
        currentModule: null,
        moduleSettingsModal: null,
        item: null,
        show2FASetup: false,
        qrCodeUrl: '',
        otpCode: '',
        verifying2FA: false,
        secret: '',
        refreshTokens: [],
        billingSubscription: null,
        billingInvoices: [],
        billingLoading: false,
        invoiceDownloading: null,
        activeSalesTab: 'general',
        activeCrmTab: 'clients',
        activePurchaseTab: 'general',
        activeInventoryTab: 'general',
        activePosTab: 'template',
        activeSubscriptionTab: 'membership_card',
        activeDashboardTab: 'general',
        activeContractTab: 'template',
        activeLeadTab: 'statuses',
        activeProjectTab: 'task_statuses',

        }
  },
  mounted() {
    



    // Inject Crisp chat script

    // this.crispScript = document.createElement('script');
    // this.crispScript.type = 'text/javascript';
    // this.crispScript.async = true;
    // this.crispScript.src = 'https://client.crisp.chat/l.js';
    // window.$crisp = [];
    // window.CRISP_WEBSITE_ID = "3aa4fac3-42c0-4b5d-9e93-19d7def099d1";
    // document.head.appendChild(this.crispScript);

    this.modules = this.copyModules(this.$store.state.modules)
    this.$nextTick(() => {
        this.initialModulesLoaded = true;
    });

    // eslint-disable-next-line no-undef
    this.createModal = new bootstrap.Modal(document.getElementById('show-advanced-modal'))
    // eslint-disable-next-line no-undef
    this.moduleSettingsModal = new bootstrap.Modal(document.getElementById('module-settings-modal'))

    // Read tab from route params (e.g. /settings/modules)
    if (this.$route.params && this.$route.params.tab) {
        const urlTab = this.$route.params.tab;
        // Map URL-friendly names back to internal step names
        const reverseTabMap = { 'general': 'business', 'subscription': 'billing' };
        const mappedStep = reverseTabMap[urlTab] || urlTab;
        this.step = mappedStep;
    } else if (this.$route.query && this.$route.query.tab) {
        // Fallback: also support ?tab= query for backwards compat
        const qtab = this.$route.query.tab
        if (qtab === 'pos_templates') {
            this.step = 'templates'
            this.templateTab = 'pos'
        } else {
            this.step = qtab
        }
    }

    this.openModuleSettingsFromRoute();

    if (this.$route.query && this.$route.query.openPaymentMethods) {
        this.openPaymentMethodsModal();
    }

    // App.vue has already loaded the business before this view is mounted.
    // Re-fetching it here, followed by templates, made the full-page loader
    // disappear and immediately reappear. Load only the active tab's
    // additional data and keep its loading state local to that tab.
    this.$nextTick(() => {
        this.initialSettingsLoaded = true;
    });
    this.loadActiveTabData(this.step);
  },

  methods : {
    loadActiveTabData(step) {
        if (step === 'templates') {
            this.getTemplates({ showLoading: false });
        } else if (step === 'integrations' && this.showLegacyIntegrations) {
            this.loadEmailIntegration();
            this.loadPrinterIntegration();
        } else if (step === 'security') {
            this.loadRefreshTokens();
        } else if (step === 'billing') {
            this.loadBillingSubscription();
        }
    },
    formatPlanAmount(price) {
        return Number(price || 0).toLocaleString('fr-MA')
    },
    formatBillingDate(date) {
        return date ? new Intl.DateTimeFormat(this.$i18n.locale || 'fr', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        }).format(new Date(date)) : '-'
    },
    async loadBillingSubscription() {
        this.billingLoading = true
        try {
            const response = await helper.customGet(`${process.env.VUE_APP_API}/billing/subscription`)
            this.billingSubscription = response.data.billing || null
            this.billingInvoices = response.data.invoices || []
        } catch (error) {
            this.billingSubscription = null
            this.billingInvoices = []
        } finally {
            this.billingLoading = false
        }
    },
    async downloadBillingInvoice(invoice) {
        this.invoiceDownloading = invoice.id
        try {
            const response = await axios.get(
                `${process.env.VUE_APP_API}/billing/invoices/${invoice.id}/download`,
                { responseType: 'blob' }
            )
            const url = window.URL.createObjectURL(response.data)
            const link = document.createElement('a')
            link.href = url
            link.download = invoice.file_name || 'invoice.pdf'
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(url)
        } catch (error) {
            this.$toast.error(this.$t('invoice_download_failed'))
        } finally {
            this.invoiceDownloading = null
        }
    },
        async savePriceIncludesTax(){
        try{
            if(!this.business.metadata){
                this.business.metadata = {}
            }
            const payload = {
                metadata: {
                    ...this.business.metadata,
                    price_includes_tax: !!this.business.metadata.price_includes_tax
                }
            }
           await helper.customPost(`${process.env.VUE_APP_API}/businesses`, payload, { showToast: true })
            // sync store
            this.business.metadata = payload.metadata
            this.$store.commit('SET_BUSINESS', this.business)
        }catch(e){
            alert('Failed to save setting')
        }
    },
    async save(){
        try{
            this.loading = true
            const currentLanguage = localStorage.getItem('currentLang')
            const newLanguage = this.business.language
            
            // Ensure metadata exists
            if(!this.business.metadata){
                this.business.metadata = {}
            }
            
            
            await helper.customPost(`${process.env.VUE_APP_API}/businesses`,this.business,{showToast:true})
            await this.getSettings({ showLoading: false })
            this.isDirty = false
            this.loading = false
            
            // Reload page if language changed
            if (currentLanguage !== newLanguage) {
                window.location.reload()
            }
        }catch(error){
            this.loading = false
        }finally{
            this.loading = false
        }

    },
    async getSettings({ showLoading = true } = {}){
        try{
            if (showLoading) this.loading = true
            const response = await helper.customGet(`${process.env.VUE_APP_API}/businesses`)
            const business = response.data.business

            if(!business.metadata){
                business.metadata = {
                    "references" : {
                        "quote" : "QUOTE-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}",
                        "delivery" : "DEL-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}",
                        "invoice" : "INVOICE-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}",
                        "credit_note" : "INVOICE-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}",
                        "order" : "ORDER-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}",
                        "purchase" : "PURCHASE-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}",
                        "reception" : "RECEPTION-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}",
                        "payment" : "PAYMENT-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}",
                        "return" : "RETURN-00{{ID}}-{{MONTH}}-{{DAY}}-{{YEAR}}"
                    }
                }
            }

            //currency 
            if(response.data.business.currency){
                business.currency = response.data.business.currency
            }

            //language 
            if(response.data.user.language){
                business.language = response.data.user.language
                localStorage.setItem('currentLang', business.language)
            }
            
            if(response.data.user){
                 this.$store.commit('SET_USER', response.data.user)
            }

            this.$store.commit('SET_BUSINESS', business)
            this.$nextTick(() => {
                this.initialSettingsLoaded = true;
            });
        }catch(error){
            // The request helper already reports API failures.
        }finally{
            if (showLoading) this.loading = false
        }
    },
    async getTemplates({ showLoading = true } = {}){
        try{
            if (showLoading) this.loading = true
            const response = await helper.customGet(`${process.env.VUE_APP_API}/templates`)
            this.templates = response.data.data
            for(let i = 0 ; i < this.templates.length ; i++){
                this.templates[i].data = helper.jsonToHtml(JSON.parse(this.templates[i].data))
            }
            
            // Load membership card template
            const membershipCardTemplate = this.templates.find(t => t.type === 'membership_card');
            if (membershipCardTemplate) {
                this.membershipCardTemplateId = membershipCardTemplate.id;
                this.membershipCardTemplate = membershipCardTemplate.data;
            }
            
        }catch(error){
            // The request helper already reports API failures.
        }finally{
            if (showLoading) this.loading = false
        }
    },
    async onMembershipCardTemplateSaved() {
        await this.getTemplates();
        window.vueOpener.open({
            message: this.$t('template_saved_successfully'),
            type: 'success',
            position: 'bottom'
        });
    },
    async onMembershipCardTemplateDeleted() {
        this.membershipCardTemplateId = null;
        this.membershipCardTemplate = null;
        await this.getTemplates();
        window.vueOpener.open({
            message: this.$t('template_deleted_successfully'),
            type: 'success',
            position: 'bottom'
        });
    },
    formatDate(date){
        return helper.formatDate(date)
    },
    formatDateFromNow(date){
        return helper.formatDateFromNow(date)
    },
    editTemplate(template){
        this.selected_template = template.data
        this.template_id = template.id
        this.createModalisOpen = true
        this.isModalOpen = true
        // this.createModal.show()
    },
     viewRow(){
        this.item = {
            "id": "af31f4f4-99e2-45d8-9e18-6695a3e5be06",
            "reference": "Q-0021-14-11-2025",
            "date": "2025-11-14T00:00:00.000Z",
            "notes": null,
            "sub_total": 3000,
            "total_vat": 600,
            "total_discount": 0,
            "total": 3600,
            "status": "pending",
            "products": [
                {
                    "id": "af725cdc-549f-4f61-ade6-d2e16513362c",
                    "inventory_id": "27559a90-a688-4e60-a351-35f4c9af39b8",
                    "product_id": "e88dd8e4-75ae-4578-adf7-7f34d798b319",
                    "product_label": "Test Product 1",
                    "purchase_price": 2500,
                    "custom_product": false,
                    "price": 3000,
                    "discount": 0,
                    "quantity": 1,
                    "vat": 20,
                    "total": 3600,
                    "sub_total": 3000,
                }
            ],
            "client": {
                "id": "b112bf90-8f05-428e-8011-bd9a1e2be9e9",
                "reference": "CL-6",
                "name": "Test Client",
                "email": "testclient@example.com",
                "phone": "",
                "address": "",
                "country": "",
                "city": "",
                "state": "",
                "zip_code": "",
                "tax_id": "",
                "vat_number": "",
                "notes": "",
                "business_id": "5b35067e-74a2-4d27-b156-534d359952fe",
                "UserId": "4ba603e9-d761-4fc9-a2e8-f605c1dc6e87"
            },
            "user": {
                "id": "4ba603e9-d761-4fc9-a2e8-f605c1dc6e87",
                "name": "demo admin",
                "email": "demo@gstocky.com"
            }
        } 
        this.invoicePreviewModalisOpen = true
    },
    modalClosed(){
        this.isModalOpen = false 
        this.$emit('modalClosed', true)
    },
    newTemplate(){
        this.selected_template = null
        this.template_id = null
        this.createModalisOpen = true
        this.isModalOpen = true
        // this.createModal.show()
    },
    async saveTemplate() {
        this.$refs.child.saveTemplate()
    },
    async deleteTemplate(){
        this.$refs.child.deleteTemplate()
    },
    previewImage(event) {
        this.loadingImage = true
        this.business.logo = null
        this.onUpload(event.target.files[0])
    },
    async onUpload(file){
        // if(this.business && this.business.status != 'active') return;
        const url = await helper.customUploadFile(file,`businesses/${this.business.id}/logo/${helper.generateRandString(20)}`,{products : true})
        this.loadingImage = false
        this.business.logo = url
        this.save()
       
    },
    previewStamp(event) {
        this.loadingStamp = true
        this.business.electronic_stamp = null
        this.onUploadStamp(event.target.files[0])
    },
    async onUploadStamp(file){
        const url = await helper.customUploadFile(file,`businesses/${this.business.id}/stamp/${helper.generateRandString(20)}`,{products : true})
        this.loadingStamp = false
        this.business.electronic_stamp = url
        this.save()
    },
    async deleteLogo() {
        this.business.logo = '-1';
        this.save();
    },
    async deleteStamp() {
        this.business.electronic_stamp = '-1';
        this.save();
    },
    showAdvanced(){
        this.createModalisOpen = true
        this.createModal.show()
    },
    openPaymentMethodsModal() {
        this.$refs.paymentMethodsModal.show()
    },
    addNewField() {
        if (!this.business.extra_fields) {
            this.business.extra_fields = [];
        }
        this.business.extra_fields.push({
            field_name: '',
            field_value: ''
        });
    },
    async removeField(index) {
        if (this.business.extra_fields && index >= 0) {
            const field = this.business.extra_fields[index];
            if (field.id) {
                try {
                    await helper.customDelete(`${process.env.VUE_APP_API}/custom-fields/${field.id}`, { showToast: true });
                } catch (error) {
                    return;
                }
            }
            this.business.extra_fields.splice(index, 1);
        }
    },
    async saveFields() {
        try {
            if (!this.business.extra_fields) {
                this.business.extra_fields = [];
            }
            const payload = {
                extra_fields: this.business.extra_fields
            };
            await helper.customPost(`${process.env.VUE_APP_API}/custom-fields`, payload, { showToast: true });
            this.$store.commit('SET_BUSINESS', this.business);
            this.createModalisOpen = false
            this.createModal.hide()
        } catch (e) {
            alert('something went wrong')
        }
    },
    async saveSidebarSettings() {
        this.loading = true
        const modules = this.modules.map(module => {
            if (this.isModuleEligible(module)) {
                return {
                    ...module,
                    items: (module.items || []).map(item => ({
                        ...item,
                        enabled: this.isModuleItemEligible(module, item) ? item.enabled : false
                    })),
                    enabled: (module.items || []).some(item => this.isModuleItemEligible(module, item) && item.enabled)
                }
            }
            return {
                ...module,
                enabled: false,
                items: (module.items || []).map(item => ({
                    ...item,
                    enabled: false
                }))
            }
        })
        await helper.customPost(`${process.env.VUE_APP_API}/modules`, modules, { showToast: true });
        this.$store.commit('SET_MODULES', modules)
        this.modules = this.copyModules(this.$store.state.modules)
        this.loading = false
        this.isDirty = false
    },
    copyModules(modules = []) {
        return modules.map(module => ({ ...module }))
    },
    chunkArray(array, chunkSize) {
        const chunks = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            chunks.push(array.slice(i, i + chunkSize));
        }
        return chunks;
    },
    toggleModule(module) {
        if (!this.isModuleEligible(module)) return;
        
        const isEnabled = this.isModuleEnabled(module);
        module.items.forEach(item => {
            item.enabled = this.isModuleItemEligible(module, item) ? !isEnabled : false;
        });
        // Update the module's enabled status based on its items
        module.enabled = module.items.some(item => item.enabled);

        // Auto save on toggle for better UX (optional, but xoxovi feels immediate)
        // this.saveSidebarSettings(); 
    },
    getModuleColor(moduleKey) {
        const colors = {
            'dashboard': '#4a6cf7',
            'crm': '#00a09d',
            'inventory': '#d9363e',
            'sales': '#7c7bad',
            'purchases': '#875a7b',
            'pos': '#f06292',
            'finance': '#3eb4e4',
            'attachments': '#607d8b',
            'subscription_management': '#ff9800',
            'reservations': '#4caf50',
            'accountant': '#1976d2',
            'project_management': '#9c27b0',
            'hr': '#c44033',
            'advanced_insights': '#3f51b5',
            'contracts': '#795548',
            'planning': '#008784',
            'leads': '#e91e63',
            'settings': '#333333'
        };
        return colors[moduleKey] || '#1a1a1a';
    },
    isModuleEnabled(module) {
        // Check if at least one item is enabled
        return module.items.some(item => item.enabled && this.isModuleItemEligible(module, item));
    },
    isModuleEligible(module) {
        return module?.module_key === 'settings' || canPlanAccessModule(this.currentPlanKey, module?.module_key);
    },
    isModuleItemEligible(module, item) {
        return module?.module_key === 'settings' || canPlanAccessModuleItem(this.currentPlanKey, module?.module_key, item?.permission, item?.title);
    },
    goToUpgrade(module) {
        this.$router.push({
            path: '/subscribe',
            query: {
                from: 'settings_modules',
                module: module?.module_key,
                plan: this.currentPlanKey
            }
        })
    },
    async toggleEmailIntegration() {
        if (this.emailIntegration.enabled) {
            // If enabling, check if we have existing integration
            await this.loadEmailIntegration();
        } else {
            // If disabling, clear the form
            this.emailIntegration.settings.auth.user = '';
            this.emailIntegration.settings.auth.pass = '';
            this.testEmailAddress = '';
        }
    },
    async loadEmailIntegration() {
            const response = await helper.customGet(`${process.env.VUE_APP_API}/integrations?type=email`);
            if (response.data.data && response.data.data.length > 0) {
                const integration = response.data.data[0];
                this.emailIntegration.enabled = integration.enabled;
                if (integration.settings) {
                    const settings = integration.settings;
                    this.emailIntegration.settings = settings;
                }
            }
    },
    async loadPrinterIntegration() {
            const response = await helper.customGet(`${process.env.VUE_APP_API}/integrations?type=printer`);
            if (response.data.data && response.data.data.length > 0) {
                const integration = response.data.data[0];
                this.printerIntegration.enabled = integration.enabled;
                if (integration.settings) {
                    this.printerIntegration.settings = integration.settings;
                }
            }
    },
    async testEmailIntegration() {
        if (!this.emailIntegration.enabled || !this.emailIntegration.settings.auth.user || !this.emailIntegration.settings.auth.pass) {
            alert('Please enable and configure email integration first.');
            return;
        }
        
        if (!this.testEmailAddress) {
            alert('Please enter a test email address.');
            return;
        }
        
        this.testingEmail = true;
        try {
            // First save the integration if it doesn't exist
            await this.saveEmailIntegration();
            
            // Then test it
            const response = await helper.customGet(`${process.env.VUE_APP_API}/integrations?type=email`);
            if (response.data.data && response.data.data.length > 0) {
                const integration = response.data.data[0];
                await helper.customPost(`${process.env.VUE_APP_API}/integrations/${integration.id}/test-email`, {
                    testEmail: this.testEmailAddress
                }, { showToast: true });
                alert('Test email sent successfully!');
            }
        } catch (error) {
            alert('Failed to send test email: ' + (error.response?.data?.message || error.message));
        } finally {
            this.testingEmail = false;
        }
    },
    async saveEmailIntegration() {
        if (!this.emailIntegration.enabled) {
            return;
        }
        
        this.savingIntegration = true;
        try {
            const response = await helper.customGet(`${process.env.VUE_APP_API}/integrations?type=email`);
            
            if (response.data.data && response.data.data.length > 0) {
                // Update existing integration
                const integration = response.data.data[0];
                await helper.customPatch(`${process.env.VUE_APP_API}/integrations/${integration.id}`, {
                    settings: this.emailIntegration.settings,
                    enabled: this.emailIntegration.enabled
                }, { showToast: true });
            } else {
                // Create new integration
                await helper.customPost(`${process.env.VUE_APP_API}/integrations`, {
                    type: 'email',
                    settings: this.emailIntegration.settings,
                    enabled: this.emailIntegration.enabled
                }, { showToast: true });
            }
            
            alert('Email integration settings saved successfully!');
        } catch (error) {
            alert('Failed to save email integration settings: ' + (error.response?.data?.message || error.message));
        } finally {
            this.savingIntegration = false;
        }
    },
    async savePrinterIntegration() {
        if (!this.printerIntegration.enabled) {
            // If disabled, still persist state
        }
        this.savingIntegration = true;
        try {
            const response = await helper.customGet(`${process.env.VUE_APP_API}/integrations?type=printer`);
            if (response.data.data && response.data.data.length > 0) {
                const integration = response.data.data[0];
                await helper.customPatch(`${process.env.VUE_APP_API}/integrations/${integration.id}`, {
                    settings: this.printerIntegration.settings,
                    enabled: this.printerIntegration.enabled
                }, { showToast: true });
            } else {
                await helper.customPost(`${process.env.VUE_APP_API}/integrations`, {
                    type: 'printer',
                    settings: this.printerIntegration.settings,
                    enabled: this.printerIntegration.enabled
                }, { showToast: true });
            }
            alert('Printer integration settings saved successfully!');
        } catch (error) {
            alert('Failed to save printer integration settings: ' + (error.response?.data?.message || error.message));
        } finally {
            this.savingIntegration = false;
        }
    },
    togglePrinterIntegration() {
        if (!this.printerIntegration.enabled) {
            // keep URL but mark as disabled
        }
    },
    async toggle2FA() {
        if (this.currentUser.two_factor_enabled) {
            // Disable
            const result = await this.$swal({
                title: this.$t('are_you_sure'),
                text: this.$t('are_you_sure_disable_2fa'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: this.$t('yes_delete_it'),
                cancelButtonText: this.$t('cancel')
            });
            
            if (result.isConfirmed) {
                try {
                    await helper.customPost(`${process.env.VUE_APP_API}/2fa/disable`, {}, { showToast: true });
                    // Update local user state
                    const user = { ...this.currentUser, two_factor_enabled: false };
                    this.$store.commit('SET_USER', user);
                    this.show2FASetup = false;
                } catch (e) {
                    this.$swal({
                        icon: 'error',
                        title: this.$t('error'),
                        text: 'Failed to disable 2FA'
                    });
                }
            }
        } else {
            // Enable - show setup
            this.show2FASetup = true;
            this.generate2FA();
        }
    },
    async generate2FA() {
        try {
            const response = await helper.customPost(`${process.env.VUE_APP_API}/2fa/generate`, {});
            this.qrCodeUrl = response.data.qr_code;
            this.secret = response.data.secret;
        } catch (e) {
            this.$swal({
                icon: 'error',
                title: this.$t('error'),
                text: 'Failed to generate 2FA secret'
            });
        }
    },
    async verifyAndEnable2FA() {
        this.verifying2FA = true;
        try {
            await helper.customPost(`${process.env.VUE_APP_API}/2fa/verify`, {
                token: this.otpCode,
                secret: this.secret
            }, { showToast: true });
            
            // Update local user state
            const user = { ...this.currentUser, two_factor_enabled: true };
            this.$store.commit('SET_USER', user);
            
            this.show2FASetup = false;
            this.otpCode = '';
            
            this.$swal({
                icon: 'success',
                title: this.$t('success'),
                text: this.$t('2fa_enabled_successfully')
            });
        } catch (e) {
            this.$swal({
                icon: 'error',
                title: this.$t('error'),
                text: this.$t('invalid_code')
            });
        } finally {
            this.verifying2FA = false;
        }
    },
    async testPrinter() {
        if (!this.printerIntegration.enabled || !this.printerIntegration.settings.url) {
            alert('Please enable and set a printer URL.');
            return;
        }
        this.testingPrinter = true;
        try {
            // Persist settings before test so backend sees the latest URL
            await this.savePrinterIntegration();
            // Send a tiny test job via /api/print
            const sample = 'Test print from GStocky at ' + new Date().toLocaleString();
            await helper.customPost(`${process.env.VUE_APP_API}/print`, { data: sample }, { showToast: true });
            alert('Test print sent!');
        } catch (e) {
            alert('Failed to send test print: ' + (e.response?.data?.message || e.message));
        } finally {
            this.testingPrinter = false;
        }
    },
    async loadRefreshTokens() {
        try {
            const response = await helper.customGet(`${process.env.VUE_APP_API}/refresh-tokens`);
            this.refreshTokens = response.data.map(token => ({
                ...token,
                showIp: false,
                parsedUserAgent: this.parseUserAgent(token.user_agent)
            }));
        } catch (e) {
            /* ignore */
        }
    },
    parseUserAgent(userAgent) {
        if (!userAgent) return 'Unknown Device';
        
        let device = 'Unknown Device';
        let browser = '';

        if (/mobile/i.test(userAgent)) {
            device = 'Mobile';
            if (/iphone/i.test(userAgent)) device += ' (iPhone)';
            else if (/ipad/i.test(userAgent)) device += ' (iPad)';
            else if (/android/i.test(userAgent)) device += ' (Android)';
        } else {
            device = 'PC';
            if (/mac/i.test(userAgent)) device += ' (Mac)';
            else if (/win/i.test(userAgent)) device += ' (Windows)';
            else if (/linux/i.test(userAgent)) device += ' (Linux)';
        }

        if (/chrome/i.test(userAgent) && !/edg/i.test(userAgent)) browser = 'Chrome';
        else if (/firefox/i.test(userAgent)) browser = 'Firefox';
        else if (/safari/i.test(userAgent) && !/chrome/i.test(userAgent)) browser = 'Safari';
        else if (/edg/i.test(userAgent)) browser = 'Edge';
        else if (/opera|opr/i.test(userAgent)) browser = 'Opera';

        return browser ? `${device} - ${browser}` : device;
    },
    async revokeRefreshToken(id) {
        const result = await this.$swal({
            title: this.$t('are_you_sure'),
            text: this.$t('revoke_access_confirmation'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: this.$t('yes_revoke_it'),
            cancelButtonText: this.$t('cancel')
        });

        if (result.isConfirmed) {
            try {
                await helper.customDelete(`${process.env.VUE_APP_API}/refresh-tokens/${id}`);
                this.refreshTokens = helper.withoutDeletedRecords(this.refreshTokens, id);
                this.$toast.success(this.$t('access_revoked_successfully'));
            } catch (error) {
                this.$toast.error(this.$t('failed_to_revoke_access'));
            }
        }
    },
    handleTabChange(newStep) {
        this.step = newStep;
        // Map internal step names to URL-friendly tab names
        const tabMap = { 'business': 'general', 'billing': 'subscription' };
        const urlTab = tabMap[newStep] || newStep;
        if (this.$route.params.tab !== urlTab) {
            this.$router.replace({ path: `/settings/${urlTab}` }).catch(() => {});
        }
        this.loadActiveTabData(newStep);
    },
    hasModuleSettings(module) {
        // Define which modules have settings
        const modulesWithSettings = ['dashboard', 'subscription_management', 'pos', 'sales', 'purchases', 'inventory', 'crm', 'contracts', 'leads', 'project_management'];
        if (module.module_key === 'project_management' && helper.checkAccess('edit_tasks') <= 0) return false;
        return modulesWithSettings.includes(module.module_key);
    },
    setModuleSettingsSection(moduleKey, section) {
        if (!section) return;

        const sectionConfig = {
            dashboard: { property: 'activeDashboardTab', allowed: ['general'] },
            subscription_management: { property: 'activeSubscriptionTab', allowed: ['membership_card', 'general'] },
            pos: { property: 'activePosTab', allowed: ['template'] },
            sales: { property: 'activeSalesTab', allowed: ['general', 'template', 'suggestions', 'reference_builder'] },
            purchases: { property: 'activePurchaseTab', allowed: ['general', 'template', 'reference_builder'] },
            inventory: { property: 'activeInventoryTab', allowed: ['general', 'columns'] },
            crm: { property: 'activeCrmTab', allowed: ['clients', 'suppliers'] },
            contracts: { property: 'activeContractTab', allowed: ['template'] },
            leads: { property: 'activeLeadTab', allowed: ['statuses', 'sources', 'columns', 'rules'] },
            project_management: { property: 'activeProjectTab', allowed: ['task_statuses'] }
        };
        const config = sectionConfig[moduleKey];
        if (config && config.allowed.includes(section)) {
            this[config.property] = section;
        }
    },
    openModuleSettingsFromRoute() {
        const moduleKey = this.$route.query && this.$route.query.open;
        if (!moduleKey || !this.moduleSettingsModal) return;

        const module = this.modules.find(item => item.module_key === moduleKey);
        if (module && this.hasModuleSettings(module)) {
            this.openModuleSettings(module, this.$route.query.section);
        }
    },
    openModuleSettings(module, section = null) {
        if (module.module_key === 'project_management' && helper.checkAccess('edit_tasks') <= 0) return;
        this.currentModule = module;
        this.setModuleSettingsSection(module.module_key, section);
        
        // Load module-specific settings
        if (module.module_key === 'subscription_management') {
            // Load subscription settings if needed
            if (this.$refs.subscriptionSettings) {
                this.$refs.subscriptionSettings.loadMembershipCardTemplate();
            }
        } else if (module.module_key === 'pos') {
            // Load POS settings if needed
        } else if (module.module_key === 'sales') {
            // Load sales settings if needed
        } else if (module.module_key === 'purchases') {
            // Load purchase settings if needed
        }
        
        this.moduleSettingsModal.show();
    },
    async saveModuleSettings() {
        if (!this.currentModule) return;
        
        // Save based on module type
        if (this.currentModule.module_key === 'subscription_management') {
            // Subscription settings are saved individually within the component
            // Just close the modal
        } else if (this.currentModule.module_key === 'pos') {
            // POS settings are saved individually within the component
            // Just close the modal
        } else if (this.currentModule.module_key === 'sales') {
            // Sales settings are saved individually within the component
            // Just close the modal
        } else if (this.currentModule.module_key === 'purchases') {
            // Purchase settings are saved individually within the component
            // Just close the modal
        } else if (this.currentModule.module_key === 'leads') {
            // Lead settings are saved individually within the component
            // Just close the modal
        }
        
        this.moduleSettingsModal.hide();
    }

  },
  watch: {
    '$route.fullPath'() {
        this.openModuleSettingsFromRoute();
    },
    modules: {
        handler() {
            if (this.initialModulesLoaded) {
                this.isDirty = true;
            }
        },
        deep: true
    },
    business: {
        handler() {
            if (this.initialSettingsLoaded) {
                this.isDirty = true;
            }
        },
        deep: true
    }
  },
  computed : {
    filteredModules() {
        let filtered = [...this.modules];
        
        // Category filtering
        if (this.activeCategory !== 'all') {
            filtered = filtered.filter(m => {
                const key = m.module_key;
                if (this.activeCategory === 'operations') return ['sales', 'pos', 'inventory', 'purchases'].includes(key);
                if (this.activeCategory === 'crm') return ['crm', 'leads', 'marketing', 'dashboard', 'advanced_insights'].includes(key);
                if (this.activeCategory === 'planning') return ['hr', 'planning', 'project_management', 'reservations'].includes(key);
                if (this.activeCategory === 'finance') return ['finance', 'accountant', 'subscription_management'].includes(key);
                if (this.activeCategory === 'system') return ['settings', 'attachments'].includes(key);
                return true;
            });
        }
        
        // Search filtering
        if (this.searchQuery) {
            const query = this.searchQuery.toLowerCase();
            filtered = filtered.filter(m => 
                this.$t(m.title).toLowerCase().includes(query) || 
                this.$t(m.description || '').toLowerCase().includes(query)
            );
        }
        
        // Always put settings module at the end
        const settingsIndex = filtered.findIndex(m => m.module_key === 'settings');
        if (settingsIndex !== -1) {
            const settingsModule = filtered.splice(settingsIndex, 1)[0];
            filtered.push(settingsModule);
        }
        
        return filtered;
    },
    currentUser() {
        return this.$store.getters.USER;
    },
    business() { 
        return this.$store.getters.BUSINESS 
    },
    currentPlanKey() {
        return getBusinessPlanKey(this.business)
    },
    currentPricingPlan() {
        return getBusinessPricingPlan(this.business)
    },
    role() { 
        return this.$store.getters.ROLE 
    },
    priceIncludesTax: {
        get(){
            return !!(this.business && this.business.metadata && this.business.metadata.price_includes_tax)
        },
        set(v){
            if(!this.business.metadata){
                this.business.metadata = {}
            }
            this.business.metadata.price_includes_tax = v
            this.savePriceIncludesTax()
        }
    }
  }
}
</script>

<style scoped>

/* Sidebar Navigation Styles */
.settings-sidebar {
    background-color: #fff;
    border-right: 1px solid #eee;
    padding: 0 !important; /* Force removal of padding if any utility classes remain */
}

.settings-sidebar-nav .nav-link {
    color: #666;
    padding: 1rem 1.5rem; /* Larger padding */
    margin-bottom: 0; /* Remove margin between items */
    border-radius: 0; /* Square edges for flush look */
    font-weight: 500;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    font-size: 16px; /* Bigger text */
}

.settings-sidebar-nav .nav-link:hover {
    background-color: #f8f9fa;
    color: #000;
}

.settings-sidebar-nav .nav-link.active {
    background-color: #f0f2f5;
    color: #000 !important; /* Active text strictly black */
    font-weight: 600;
}

.settings-sidebar-nav .nav-link i {
    font-size: 1.2rem; /* Bigger icon */
    opacity: 1; /* More visible */
    margin-right: 10px;
}

.settings-sidebar-nav .nav-link.active i {
    opacity: 1;
    color: #000;
}

.contract-settings-layout {
    background: #f8f9fc;
    min-height: 70vh;
}

.contract-settings-sidebar {
    background: #fff;
    border-right: 1px solid #e5e8f0;
    width: 220px;
}

.contract-settings-sidebar .settings-sidebar-nav {
    padding: 12px;
}

.contract-settings-sidebar .settings-sidebar-nav .nav-link {
    border-radius: 10px;
    color: #475569;
    font-size: 0.92rem;
    font-weight: 700;
    margin-bottom: 6px;
    padding: 10px 12px;
}

.contract-settings-sidebar .settings-sidebar-nav .nav-link:hover {
    background: #f8fafc;
    color: #0f172a;
}

.contract-settings-sidebar .settings-sidebar-nav .nav-link.active {
    background: #eef4ff;
    color: #2563eb !important;
}

.contract-settings-sidebar .settings-sidebar-nav .nav-link.active i {
    color: #2563eb;
}

.contract-settings-panel {
    background: #f8f9fc;
}


.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link{
    color:#303030 !important
}

.current-plan-card {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.07);
    padding: 20px;
}

.current-plan-head {
    align-items: flex-start;
    display: flex;
    gap: 18px;
    justify-content: space-between;
}

.current-plan-kicker {
    color: #2563eb;
    display: block;
    font-size: 0.68rem;
    font-weight: 800;
    margin-bottom: 4px;
    text-transform: uppercase;
}

.current-plan-head h5 {
    color: #0f172a;
    font-weight: 850;
    margin: 0 0 5px;
}

.current-plan-head p {
    color: #64748b;
    font-size: 0.9rem;
    margin: 0;
}

.current-plan-price {
    align-items: baseline;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    color: #0f172a;
    display: flex;
    gap: 5px;
    justify-content: center;
    min-width: 150px;
    padding: 12px 14px;
    text-align: center;
    white-space: nowrap;
}

.current-plan-price strong,
.current-plan-price span {
    font-size: 1rem;
    font-weight: 850;
}

.current-plan-price small {
    color: #64748b;
    font-size: 0.78rem;
    font-weight: 700;
}

.current-plan-actions {
    align-items: center;
    display: flex;
    gap: 12px;
    margin-top: 16px;
}

.subscription-period {
    border-top: 1px solid #e2e8f0;
    display: grid;
    gap: 12px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    margin-top: 18px;
    padding-top: 18px;
}

.subscription-period-item {
    background: #f8fafc;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 12px;
}

.subscription-period-item span {
    color: #64748b;
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
}

.subscription-period-item strong {
    color: #0f172a;
    font-size: 0.88rem;
}

.billing-invoices-card {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    overflow: hidden;
}

.billing-invoices-head {
    align-items: center;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    padding: 18px 20px;
}

.billing-invoices-head h6 {
    color: #0f172a;
    font-weight: 800;
    margin: 0 0 3px;
}

.billing-invoices-head p {
    color: #64748b;
    font-size: 0.8rem;
    margin: 0;
}

.invoice-count {
    align-items: center;
    background: #eef2ff;
    border-radius: 999px;
    color: #4338ca;
    display: inline-flex;
    font-size: 0.78rem;
    font-weight: 800;
    height: 28px;
    justify-content: center;
    min-width: 28px;
}

.billing-empty-state {
    align-items: center;
    color: #94a3b8;
    display: flex;
    flex-direction: column;
    font-size: 0.86rem;
    gap: 7px;
    padding: 34px 20px;
}

.billing-empty-state i {
    font-size: 1.5rem;
}

.billing-invoice-row {
    align-items: center;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    gap: 12px;
    padding: 14px 20px;
}

.billing-invoice-row:last-child {
    border-bottom: 0;
}

.billing-invoice-icon {
    align-items: center;
    background: #fef2f2;
    border-radius: 8px;
    color: #dc2626;
    display: flex;
    flex: 0 0 36px;
    height: 36px;
    justify-content: center;
}

.billing-invoice-details {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
}

.billing-invoice-details strong {
    color: #0f172a;
    font-size: 0.86rem;
    overflow-wrap: anywhere;
}

.billing-invoice-details span {
    color: #64748b;
    font-size: 0.75rem;
}

@media (max-width: 768px) {
    .current-plan-head,
    .current-plan-actions {
        align-items: flex-start;
        flex-direction: column;
    }

    .current-plan-price {
        width: 100%;
    }

    .subscription-period {
        grid-template-columns: 1fr;
    }

    .billing-invoice-row {
        align-items: flex-start;
        flex-wrap: wrap;
    }
}

.table-setting-preview,
.table-setting-preview .h3,
.table-setting-preview table,
.table-setting-preview table td
{
    font-size: 9px !important;
}

.table-setting-preview table td{
    padding: 0 !important;
}

#invoice-template-builder-modal .modal-body{
    padding:0 !important
}

.table-responsive, .invoice-builder-table{
    min-height: 35% !important;
}

/* Module Cards Styling */
.modules-list, .modules-grid { width: 100%; }
.transition-all { transition: all 0.3s ease; }
.tracking-wider { letter-spacing: 0.05em; }

.module-card:hover, .module-grid-card:hover { transform: translateY(-3px); box-shadow: 0 10px 20px rgba(0,0,0,0.08) !important; }
.form-check-input:checked { background-color: #1a1a1a; border-color: #1a1a1a; }
.form-switch .form-check-input:checked { background-color: #1a1a1a; border-color: #1a1a1a; }
.form-check-input:disabled { opacity: 0.5; cursor: not-allowed; }

.module-settings-btn { transition: all 0.2s ease; display: inline-flex; align-items: center; justify-content: center; }
.module-settings-btn:hover:not(:disabled) { background-color: #1a1a1a !important; color: white !important; border-color: #1a1a1a !important; transform: scale(1.05); }
.module-settings-btn:hover:not(:disabled) i { color: white !important; }

.module-expand-button {
    height: 32px;
    padding: 0;
    transition: all 0.2s ease;
    width: 32px;
}

.module-expand-button:hover:not(:disabled) {
    background-color: #1a1a1a !important;
    border-color: #1a1a1a !important;
    color: #fff !important;
}

.feature-item { transition: all 0.2s ease; }
.feature-item:hover:not(.opacity-50) { background-color: #f8f9fa !important; border-color: #1a1a1a !important; }
.feature-item:hover:not(.opacity-50) .form-check-input { border-color: #1a1a1a; }

.hover-pop:hover {
    transform: scale(1.02) translateY(-2px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}

.transition-all {
    transition: all 0.2s ease-in-out;
}

.no-scrollbar::-webkit-scrollbar {
    display: none;
}
.no-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.module-item {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.module-item-upgrade-locked {
    background: #eff6ff !important;
    border-color: #bfdbfe !important;
    color: #1d4ed8 !important;
    cursor: not-allowed !important;
}

.module-grid-card {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.module-grid-card:hover {
    transform: translateY(-5px);
}

.module-enabled { border-left: 2px solid #4A4A4A !important; }

/* xoxovi App Card Styles */
.xoxovi-app-card {
    transition: all 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
    cursor: default;
    border: none !important;
}

.xoxovi-app-card:hover {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
    transform: translateY(-4px);
}

.active-app-shadow {
    box-shadow: 0 0 0 2px #4A4A4A20, 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}

.deactivated-module {
    opacity: 0.5;
    filter: grayscale(0.6);
    transition: all 0.3s ease;
}

.deactivated-module:hover {
    opacity: 0.8;
    filter: grayscale(0.2);
}

.plan-locked-module,
.plan-locked-module:hover {
    filter: none;
    opacity: 1;
}

.module-upgrade-overlay {
    align-items: center;
    background: rgba(255, 255, 255, 0.88);
    border-radius: 10px;
    display: flex;
    inset: 0;
    justify-content: center;
    opacity: 0;
    padding: 16px;
    pointer-events: none;
    position: absolute;
    transition: opacity 0.2s ease;
    z-index: 5;
}

.plan-locked-module:hover .module-upgrade-overlay {
    opacity: 1;
    pointer-events: auto;
}

.module-upgrade-content {
    align-items: center;
    background: #fff;
    border: 1px solid #dbe4f0;
    border-radius: 8px;
    box-shadow: 0 16px 30px rgba(15, 23, 42, 0.12);
    display: flex;
    flex-direction: column;
    gap: 7px;
    max-width: 240px;
    padding: 16px;
    text-align: center;
}

.module-upgrade-icon {
    align-items: center;
    background: #eff6ff;
    border-radius: 999px;
    color: #2563eb;
    display: inline-flex;
    height: 34px;
    justify-content: center;
    width: 34px;
}

.module-upgrade-content strong {
    color: #0f172a;
    font-size: 0.92rem;
    font-weight: 850;
}

.module-upgrade-content small {
    color: #64748b;
    font-size: 0.78rem;
    line-height: 1.35;
}

.app-icon-container {
    transition: transform 0.2s ease;
}

.xoxovi-app-card:hover .app-icon-container {
    transform: scale(1.05);
}

.text-truncate-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.hover-black:hover {
    color: #000 !important;
}

.active-view {
    background-color: #4A4A4A20 !important;
    color: #4A4A4A !important;
    border: 1px solid #4A4A4A40 !important;
}

/* Sticky Save Button Animations */
.fade-up-enter-active, .fade-up-leave-active {
    transition: all 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.fade-up-enter-from {
    opacity: 0;
    transform: translate(-50%, 100px);
}
.fade-up-leave-to {
    opacity: 0;
    transform: translate(-50%, 100px);
}

.ripple {
    position: relative;
    overflow: hidden;
}

@media (max-width: 768px) {
    .filter-scroll-container {
        width: 100%;
        margin-top: 0.5rem;
    }
    
    .xoxovi-apps-controls {
        flex-direction: column;
        align-items: stretch !important;
    }
    
    .search-container {
        max-width: 100% !important;
        width: 100%;
    }
}

.no-scrollbar::-webkit-scrollbar {
    display: none;
}
.no-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

/* Invoice Simulator Styles */
.invoice-simulator-card {
    border: none !important;
    box-shadow: none !important;
}

.invoice-simulator-card .form-control:focus, 
.invoice-simulator-card .form-select:focus,
.invoice-simulator-card .logo-preview-box:hover {
    background-color: #fff !important;
    border-color: var(--bs-primary) !important;
    box-shadow: 0 0 0 3px rgba(var(--bs-primary-rgb), 0.1) !important;
}

.invoice-simulator-card input::placeholder,
.invoice-simulator-card textarea::placeholder {
    color: #cbd5e1 !important;
    font-weight: 400;
}

.invoice-simulator-card .ls-1 {
    letter-spacing: 1px;
}

.logo-preview-box:hover .bi-image {
    color: var(--bs-primary) !important;
    opacity: 0.5 !important;
}

.cursor-pointer {
    cursor: pointer;
}

.z-index-10 {
    z-index: 10;
}

.invoice-title-input:focus {
    color: var(--bs-primary) !important;
}
</style>
